
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired477"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    var mod = $parcel$modules[id];
    if (mod !== undefined) {
      return mod.exports;
    }
    var init = $parcel$inits[id];
    if (init !== undefined) {
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired477"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

if (!$parcel$global.lb) {
  // Set of loaded bundles
  $parcel$global.lb = new Set();
  // Queue of bundles to execute once they're dep bundles are loaded
  $parcel$global.bq = [];

  // Register loaded bundle
  $parcel$global.rlb = (bundle) => { $parcel$global.lb.add(bundle); $parcel$global.pq(); }

  // Run when ready
  $parcel$global.rwr = (b, r, d) => { $parcel$global.bq.push({b, r, d}); $parcel$global.pq(); }

  // Process queue
  $parcel$global.pq = () => { var runnableEntry = $parcel$global.bq.find((i) => { return i.d.every((dep) => { return $parcel$global.lb.has(dep); }); }); if (runnableEntry) { $parcel$global.bq = $parcel$global.bq.filter((i) => { return i.b !== runnableEntry.b; }); runnableEntry.r(); $parcel$global.pq(); } }
}
parcelRegister("h82at", function(module, exports) {
$parcel$export(module.exports, "createIntlCache", () => (parcelRequire("jaEJa")).createIntlCache);
$parcel$export(module.exports, "InvalidConfigError", () => (parcelRequire("iNgUL")).InvalidConfigError);
$parcel$export(module.exports, "MessageFormatError", () => (parcelRequire("iNgUL")).MessageFormatError);
$parcel$export(module.exports, "MissingDataError", () => (parcelRequire("iNgUL")).MissingDataError);
$parcel$export(module.exports, "MissingTranslationError", () => (parcelRequire("iNgUL")).MissingTranslationError);
$parcel$export(module.exports, "ReactIntlError", () => (parcelRequire("iNgUL")).IntlError);
$parcel$export(module.exports, "ReactIntlErrorCode", () => (parcelRequire("iNgUL")).IntlErrorCode);
$parcel$export(module.exports, "UnsupportedFormatterError", () => (parcelRequire("iNgUL")).UnsupportedFormatterError);
$parcel$export(module.exports, "createIntl", () => (parcelRequire("gc1M8")).createIntl);
$parcel$export(module.exports, "FormattedDateTimeRange", () => (parcelRequire("2mpAJ")).default);
$parcel$export(module.exports, "FormattedMessage", () => (parcelRequire("hiS1z")).default);
$parcel$export(module.exports, "FormattedPlural", () => (parcelRequire("hWPZ1")).default);
$parcel$export(module.exports, "FormattedRelativeTime", () => (parcelRequire("lD0Co")).default);
$parcel$export(module.exports, "injectIntl", () => (parcelRequire("cs1vW")).default);
$parcel$export(module.exports, "IntlContext", () => (parcelRequire("cs1vW")).Context);
$parcel$export(module.exports, "IntlProvider", () => (parcelRequire("30lHU")).default);
$parcel$export(module.exports, "RawIntlProvider", () => (parcelRequire("cs1vW")).Provider);
$parcel$export(module.exports, "useIntl", () => (parcelRequire("1cfRh")).default);
$parcel$export(module.exports, "FormattedListParts", () => (parcelRequire("byqwv")).FormattedListParts);
$parcel$export(module.exports, "FormattedNumberParts", () => (parcelRequire("byqwv")).FormattedNumberParts);

var $byqwv = parcelRequire("byqwv");


var $gc1M8 = parcelRequire("gc1M8");


var $2mpAJ = parcelRequire("2mpAJ");


var $cs1vW = parcelRequire("cs1vW");


var $hiS1z = parcelRequire("hiS1z");


var $hWPZ1 = parcelRequire("hWPZ1");


var $30lHU = parcelRequire("30lHU");


var $lD0Co = parcelRequire("lD0Co");


var $1cfRh = parcelRequire("1cfRh");


var $jaEJa = parcelRequire("jaEJa");

var $iNgUL = parcelRequire("iNgUL");

function $c784dd8aefc0a185$export$1adfeb024f5185b(msgs) {
    return msgs;
}
function $c784dd8aefc0a185$export$747d244ee58120dd(msg) {
    return msg;
}
var $c784dd8aefc0a185$export$40ae3194919d16b = (0, $byqwv.createFormattedComponent)('formatDate');
var $c784dd8aefc0a185$export$5b390a54f8a846f7 = (0, $byqwv.createFormattedComponent)('formatTime');
var $c784dd8aefc0a185$export$db80edc1e6b2f63d = (0, $byqwv.createFormattedComponent)('formatNumber');
var $c784dd8aefc0a185$export$f52b44e459e6e71d = (0, $byqwv.createFormattedComponent)('formatList');
var $c784dd8aefc0a185$export$c2336ea5aaab92fa = (0, $byqwv.createFormattedComponent)('formatDisplayName');
var $c784dd8aefc0a185$export$7fdc7d2c91ce149b = (0, $byqwv.createFormattedDateTimePartsComponent)('formatDate');
var $c784dd8aefc0a185$export$ec35873761676c2a = (0, $byqwv.createFormattedDateTimePartsComponent)('formatTime');
module.exports["defineMessages"] = $c784dd8aefc0a185$export$1adfeb024f5185b;
module.exports["defineMessage"] = $c784dd8aefc0a185$export$747d244ee58120dd;
module.exports["FormattedDate"] = $c784dd8aefc0a185$export$40ae3194919d16b;
module.exports["FormattedTime"] = $c784dd8aefc0a185$export$5b390a54f8a846f7;
module.exports["FormattedNumber"] = $c784dd8aefc0a185$export$db80edc1e6b2f63d;
module.exports["FormattedList"] = $c784dd8aefc0a185$export$f52b44e459e6e71d;
module.exports["FormattedDisplayName"] = $c784dd8aefc0a185$export$c2336ea5aaab92fa;
module.exports["FormattedDateParts"] = $c784dd8aefc0a185$export$7fdc7d2c91ce149b;
module.exports["FormattedTimeParts"] = $c784dd8aefc0a185$export$ec35873761676c2a;

});

parcelRegister("1cfRh", function(module, exports) {
$parcel$export(module.exports, "default", () => $0df33692cde2a04d$export$2e2bcd8739ae039);

var $42omo = parcelRequire("42omo");


var $gEeFR = parcelRequire("gEeFR");


var $cs1vW = parcelRequire("cs1vW");

function $0df33692cde2a04d$export$2e2bcd8739ae039() {
    var intl = $42omo.useContext((0, $cs1vW.Context));
    (0, $gEeFR.invariantIntlContext)(intl);
    return intl;
}

});

parcelRegister("jaEJa", function(module, exports) {

var $hXuPC = parcelRequire("hXuPC");


var $feah2 = parcelRequire("feah2");

parcelRequire("djDjD");
var $9m5ne = parcelRequire("9m5ne");


var $iNgUL = parcelRequire("iNgUL");

function $df4e8b1d4e8516c7$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}
function $df4e8b1d4e8516c7$export$d697c39a2985a4c(props, allowlist, defaults) {
    if (defaults === void 0) defaults = {};
    return allowlist.reduce(function(filtered, name) {
        if (name in props) filtered[name] = props[name];
        else if (name in defaults) filtered[name] = defaults[name];
        return filtered;
    }, {});
}
var $df4e8b1d4e8516c7$var$defaultErrorHandler = function(error) {};
var $df4e8b1d4e8516c7$var$defaultWarnHandler = function(warning) {};
var $df4e8b1d4e8516c7$export$b52f8d6fc0d47415 = {
    formats: {},
    messages: {},
    timeZone: undefined,
    defaultLocale: 'en',
    defaultFormats: {},
    fallbackOnEmptyString: true,
    onError: $df4e8b1d4e8516c7$var$defaultErrorHandler,
    onWarn: $df4e8b1d4e8516c7$var$defaultWarnHandler
};
function $df4e8b1d4e8516c7$export$51c4f4e973f2dc00() {
    return {
        dateTime: {},
        number: {},
        message: {},
        relativeTime: {},
        pluralRules: {},
        list: {},
        displayNames: {}
    };
}
function $df4e8b1d4e8516c7$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $df4e8b1d4e8516c7$export$c3f4cd5551df13fd(cache) {
    if (cache === void 0) cache = $df4e8b1d4e8516c7$export$51c4f4e973f2dc00();
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    var ListFormat = Intl.ListFormat;
    var DisplayNames = Intl.DisplayNames;
    var getDateTimeFormat = (0, $feah2.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $hXuPC.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $df4e8b1d4e8516c7$var$createFastMemoizeCache(cache.dateTime),
        strategy: (0, $feah2.strategies).variadic
    });
    var getNumberFormat = (0, $feah2.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $hXuPC.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $df4e8b1d4e8516c7$var$createFastMemoizeCache(cache.number),
        strategy: (0, $feah2.strategies).variadic
    });
    var getPluralRules = (0, $feah2.memoize)(function() {
        var _a;
        var args = [];
        for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
        return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $hXuPC.__spreadArray)([
            void 0
        ], args, false)))();
    }, {
        cache: $df4e8b1d4e8516c7$var$createFastMemoizeCache(cache.pluralRules),
        strategy: (0, $feah2.strategies).variadic
    });
    return {
        getDateTimeFormat: getDateTimeFormat,
        getNumberFormat: getNumberFormat,
        getMessageFormat: (0, $feah2.memoize)(function(message, locales, overrideFormats, opts) {
            return new (0, $9m5ne.IntlMessageFormat)(message, locales, overrideFormats, (0, $hXuPC.__assign)({
                formatters: {
                    getNumberFormat: getNumberFormat,
                    getDateTimeFormat: getDateTimeFormat,
                    getPluralRules: getPluralRules
                }
            }, opts || {}));
        }, {
            cache: $df4e8b1d4e8516c7$var$createFastMemoizeCache(cache.message),
            strategy: (0, $feah2.strategies).variadic
        }),
        getRelativeTimeFormat: (0, $feah2.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (RelativeTimeFormat.bind.apply(RelativeTimeFormat, (0, $hXuPC.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $df4e8b1d4e8516c7$var$createFastMemoizeCache(cache.relativeTime),
            strategy: (0, $feah2.strategies).variadic
        }),
        getPluralRules: getPluralRules,
        getListFormat: (0, $feah2.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (ListFormat.bind.apply(ListFormat, (0, $hXuPC.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $df4e8b1d4e8516c7$var$createFastMemoizeCache(cache.list),
            strategy: (0, $feah2.strategies).variadic
        }),
        getDisplayNames: (0, $feah2.memoize)(function() {
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new (DisplayNames.bind.apply(DisplayNames, (0, $hXuPC.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $df4e8b1d4e8516c7$var$createFastMemoizeCache(cache.displayNames),
            strategy: (0, $feah2.strategies).variadic
        })
    };
}
function $df4e8b1d4e8516c7$export$4ee1db8ce44a209b(formats, type, name, onError) {
    var formatType = formats && formats[type];
    var format;
    if (formatType) format = formatType[name];
    if (format) return format;
    onError(new (0, $iNgUL.UnsupportedFormatterError)("No ".concat(type, " format named: ").concat(name)));
}
module.exports["invariant"] = $df4e8b1d4e8516c7$export$f5708dca728d7177;
module.exports["filterProps"] = $df4e8b1d4e8516c7$export$d697c39a2985a4c;
module.exports["DEFAULT_INTL_CONFIG"] = $df4e8b1d4e8516c7$export$b52f8d6fc0d47415;
module.exports["createIntlCache"] = $df4e8b1d4e8516c7$export$51c4f4e973f2dc00;
module.exports["createFormatters"] = $df4e8b1d4e8516c7$export$c3f4cd5551df13fd;
module.exports["getNamedFormat"] = $df4e8b1d4e8516c7$export$4ee1db8ce44a209b;

});

parcelRegister("cs1vW", function(module, exports) {
$parcel$export(module.exports, "default", () => $91094644cb8e334b$export$2e2bcd8739ae039);

var $hXuPC = parcelRequire("hXuPC");


var $56GFp = parcelRequire("56GFp");


var $42omo = parcelRequire("42omo");


var $gEeFR = parcelRequire("gEeFR");

function $91094644cb8e334b$var$getDisplayName(Component) {
    return Component.displayName || Component.name || 'Component';
}
// This is primarily dealing with packaging systems where multiple copies of react-intl
// might exist
var $91094644cb8e334b$var$IntlContext = typeof window !== 'undefined' && !window.__REACT_INTL_BYPASS_GLOBAL_CONTEXT__ ? window.__REACT_INTL_CONTEXT__ || (window.__REACT_INTL_CONTEXT__ = $42omo.createContext(null)) : $42omo.createContext(null);
var $91094644cb8e334b$var$IntlConsumer = $91094644cb8e334b$var$IntlContext.Consumer, $91094644cb8e334b$var$IntlProvider = $91094644cb8e334b$var$IntlContext.Provider;
var $91094644cb8e334b$export$2881499e37b75b9a = $91094644cb8e334b$var$IntlProvider;
var $91094644cb8e334b$export$841858b892ce1f4c = $91094644cb8e334b$var$IntlContext;
function $91094644cb8e334b$export$2e2bcd8739ae039(WrappedComponent, options) {
    var _a = options || {}, _b = _a.intlPropName, intlPropName = _b === void 0 ? 'intl' : _b, _c = _a.forwardRef, forwardRef = _c === void 0 ? false : _c, _d = _a.enforceContext, enforceContext = _d === void 0 ? true : _d;
    var WithIntl = function(props) {
        return $42omo.createElement($91094644cb8e334b$var$IntlConsumer, null, function(intl) {
            var _a;
            if (enforceContext) (0, $gEeFR.invariantIntlContext)(intl);
            var intlProp = (_a = {}, _a[intlPropName] = intl, _a);
            return $42omo.createElement(WrappedComponent, (0, $hXuPC.__assign)({}, props, intlProp, {
                ref: forwardRef ? props.forwardedRef : null
            }));
        });
    };
    WithIntl.displayName = "injectIntl(".concat($91094644cb8e334b$var$getDisplayName(WrappedComponent), ")");
    WithIntl.WrappedComponent = WrappedComponent;
    if (forwardRef) return (0, (/*@__PURE__*/$parcel$interopDefault($56GFp)))(// @ts-expect-error
    $42omo.forwardRef(function(props, ref) {
        return $42omo.createElement(WithIntl, (0, $hXuPC.__assign)({}, props, {
            forwardedRef: ref
        }));
    }), WrappedComponent);
    return (0, (/*@__PURE__*/$parcel$interopDefault($56GFp)))(WithIntl, WrappedComponent);
}
module.exports["Provider"] = $91094644cb8e334b$export$2881499e37b75b9a;
module.exports["Context"] = $91094644cb8e334b$export$841858b892ce1f4c;

});

parcelRegister("gc1M8", function(module, exports) {
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $hXuPC = parcelRequire("hXuPC");








var $iNgUL = parcelRequire("iNgUL");


var $jaEJa = parcelRequire("jaEJa");

var $70f04aed693068bb$var$DATE_TIME_FORMAT_OPTIONS = [
    'formatMatcher',
    'timeZone',
    'hour12',
    'weekday',
    'era',
    'year',
    'month',
    'day',
    'hour',
    'minute',
    'second',
    'timeZoneName',
    'hourCycle',
    'dateStyle',
    'timeStyle',
    'calendar',
    // 'dayPeriod',
    'numberingSystem',
    'fractionalSecondDigits'
];
function $70f04aed693068bb$export$a7f9565e3c81cd54(_a, type, getDateTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError, timeZone = _a.timeZone;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, timeZone && {
        timeZone: timeZone
    }), format && (0, $jaEJa.getNamedFormat)(formats, type, format, onError));
    var filteredOptions = (0, $jaEJa.filterProps)(options, $70f04aed693068bb$var$DATE_TIME_FORMAT_OPTIONS, defaults);
    if (type === 'time' && !filteredOptions.hour && !filteredOptions.minute && !filteredOptions.second && !filteredOptions.timeStyle && !filteredOptions.dateStyle) // Add default formatting options if hour, minute, or second isn't defined.
    filteredOptions = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, filteredOptions), {
        hour: 'numeric',
        minute: 'numeric'
    });
    return getDateTimeFormat(locale, filteredOptions);
}
function $70f04aed693068bb$export$3ae94a2503e890a1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $70f04aed693068bb$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $iNgUL.IntlFormatError)('Error formatting date.', config.locale, e));
    }
    return String(date);
}
function $70f04aed693068bb$export$3203edd9e5edd663(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $70f04aed693068bb$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).format(date);
    } catch (e) {
        config.onError(new (0, $iNgUL.IntlFormatError)('Error formatting time.', config.locale, e));
    }
    return String(date);
}
function $70f04aed693068bb$export$a7fc3a91cb2ec376(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var from = _a[0], to = _a[1], _b = _a[2], options = _b === void 0 ? {} : _b;
    var fromDate = typeof from === 'string' ? new Date(from || 0) : from;
    var toDate = typeof to === 'string' ? new Date(to || 0) : to;
    try {
        return $70f04aed693068bb$export$a7f9565e3c81cd54(config, 'dateTimeRange', getDateTimeFormat, options).formatRange(fromDate, toDate);
    } catch (e) {
        config.onError(new (0, $iNgUL.IntlFormatError)('Error formatting date time range.', config.locale, e));
    }
    return String(fromDate);
}
function $70f04aed693068bb$export$dc1f059bce486b1(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $70f04aed693068bb$export$a7f9565e3c81cd54(config, 'date', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $iNgUL.IntlFormatError)('Error formatting date.', config.locale, e));
    }
    return [];
}
function $70f04aed693068bb$export$af6e5d7a5c73edeb(config, getDateTimeFormat) {
    var _a = [];
    for(var _i = 2; _i < arguments.length; _i++)_a[_i - 2] = arguments[_i];
    var value = _a[0], _b = _a[1], options = _b === void 0 ? {} : _b;
    var date = typeof value === 'string' ? new Date(value || 0) : value;
    try {
        return $70f04aed693068bb$export$a7f9565e3c81cd54(config, 'time', getDateTimeFormat, options).formatToParts(date); // TODO: remove this when https://github.com/microsoft/TypeScript/pull/50402 is merged
    } catch (e) {
        config.onError(new (0, $iNgUL.IntlFormatError)('Error formatting time.', config.locale, e));
    }
    return [];
}






var $1q4lC = parcelRequire("1q4lC");




var $584a8e29009be8ab$var$DISPLAY_NAMES_OPTONS = [
    'style',
    'type',
    'fallback',
    'languageDisplay'
];
function $584a8e29009be8ab$export$62fe1a4d9e891fa2(_a, getDisplayNames, value, options) {
    var locale = _a.locale, onError = _a.onError;
    var DisplayNames = Intl.DisplayNames;
    if (!DisplayNames) onError(new (0, $1q4lC.FormatError)("Intl.DisplayNames is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-displaynames\"\n", (0, $1q4lC.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $jaEJa.filterProps)(options, $584a8e29009be8ab$var$DISPLAY_NAMES_OPTONS);
    try {
        return getDisplayNames(locale, filteredOptions).of(value);
    } catch (e) {
        onError(new (0, $iNgUL.IntlFormatError)('Error formatting display name.', locale, e));
    }
}

















var $de5667d46d78974d$var$LIST_FORMAT_OPTIONS = [
    'type',
    'style'
];
var $de5667d46d78974d$var$now = Date.now();
function $de5667d46d78974d$var$generateToken(i) {
    return "".concat($de5667d46d78974d$var$now, "_").concat(i, "_").concat($de5667d46d78974d$var$now);
}
function $de5667d46d78974d$export$e8b8be48b45905bb(opts, getListFormat, values, options) {
    if (options === void 0) options = {};
    var results = $de5667d46d78974d$export$6f284aad1934db69(opts, getListFormat, values, options).reduce(function(all, el) {
        var val = el.value;
        if (typeof val !== 'string') all.push(val);
        else if (typeof all[all.length - 1] === 'string') all[all.length - 1] += val;
        else all.push(val);
        return all;
    }, []);
    return results.length === 1 ? results[0] : results.length === 0 ? '' : results;
}
function $de5667d46d78974d$export$6f284aad1934db69(_a, getListFormat, values, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    var ListFormat = Intl.ListFormat;
    if (!ListFormat) onError(new (0, $1q4lC.FormatError)("Intl.ListFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-listformat\"\n", (0, $1q4lC.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $jaEJa.filterProps)(options, $de5667d46d78974d$var$LIST_FORMAT_OPTIONS);
    try {
        var richValues_1 = {};
        var serializedValues = Array.from(values).map(function(v, i) {
            if (typeof v === 'object' && v !== null) {
                var id = $de5667d46d78974d$var$generateToken(i);
                richValues_1[id] = v;
                return id;
            }
            return String(v);
        });
        return getListFormat(locale, filteredOptions).formatToParts(serializedValues).map(function(part) {
            return part.type === 'literal' ? part : (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, part), {
                value: richValues_1[part.value] || part.value
            });
        });
    } catch (e) {
        onError(new (0, $iNgUL.IntlFormatError)('Error formatting list.', locale, e));
    }
    // @ts-ignore
    return values;
}






var $euVWZ = parcelRequire("euVWZ");

parcelRequire("djDjD");
var $9m5ne = parcelRequire("9m5ne");







function $39fedf17cfaee337$var$setTimeZoneInOptions(opts, timeZone) {
    return Object.keys(opts).reduce(function(all, k) {
        all[k] = (0, $hXuPC.__assign)({
            timeZone: timeZone
        }, opts[k]);
        return all;
    }, {});
}
function $39fedf17cfaee337$var$deepMergeOptions(opts1, opts2) {
    var keys = Object.keys((0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, opts1), opts2));
    return keys.reduce(function(all, k) {
        all[k] = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, opts1[k] || {}), opts2[k] || {});
        return all;
    }, {});
}
function $39fedf17cfaee337$var$deepMergeFormatsAndSetTimeZone(f1, timeZone) {
    if (!timeZone) return f1;
    var mfFormats = (0, $9m5ne.IntlMessageFormat).formats;
    return (0, $hXuPC.__assign)((0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, mfFormats), f1), {
        date: $39fedf17cfaee337$var$deepMergeOptions($39fedf17cfaee337$var$setTimeZoneInOptions(mfFormats.date, timeZone), $39fedf17cfaee337$var$setTimeZoneInOptions(f1.date || {}, timeZone)),
        time: $39fedf17cfaee337$var$deepMergeOptions($39fedf17cfaee337$var$setTimeZoneInOptions(mfFormats.time, timeZone), $39fedf17cfaee337$var$setTimeZoneInOptions(f1.time || {}, timeZone))
    });
}
var $39fedf17cfaee337$export$25868d1e8e76735f = function(_a, state, messageDescriptor, values, opts) {
    var locale = _a.locale, formats = _a.formats, messages = _a.messages, defaultLocale = _a.defaultLocale, defaultFormats = _a.defaultFormats, fallbackOnEmptyString = _a.fallbackOnEmptyString, onError = _a.onError, timeZone = _a.timeZone, defaultRichTextElements = _a.defaultRichTextElements;
    if (messageDescriptor === void 0) messageDescriptor = {
        id: ''
    };
    var msgId = messageDescriptor.id, defaultMessage = messageDescriptor.defaultMessage;
    // `id` is a required field of a Message Descriptor.
    (0, $jaEJa.invariant)(!!msgId, "[@formatjs/intl] An `id` must be provided to format a message. You can either:\n1. Configure your build toolchain with [babel-plugin-formatjs](https://formatjs.github.io/docs/tooling/babel-plugin)\nor [@formatjs/ts-transformer](https://formatjs.github.io/docs/tooling/ts-transformer) OR\n2. Configure your `eslint` config to include [eslint-plugin-formatjs](https://formatjs.github.io/docs/tooling/linter#enforce-id)\nto autofix this issue");
    var id = String(msgId);
    var message = // In case messages is Object.create(null)
    // e.g import('foo.json') from webpack)
    // See https://github.com/formatjs/formatjs/issues/1914
    messages && Object.prototype.hasOwnProperty.call(messages, id) && messages[id];
    // IMPORTANT: Hot path if `message` is AST with a single literal node
    if (Array.isArray(message) && message.length === 1 && message[0].type === (0, $euVWZ.TYPE).literal) return message[0].value;
    // IMPORTANT: Hot path straight lookup for performance
    if (!values && message && typeof message === 'string' && !defaultRichTextElements) return message.replace(/'\{(.*?)\}'/gi, "{$1}");
    values = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, defaultRichTextElements), values || {});
    formats = $39fedf17cfaee337$var$deepMergeFormatsAndSetTimeZone(formats, timeZone);
    defaultFormats = $39fedf17cfaee337$var$deepMergeFormatsAndSetTimeZone(defaultFormats, timeZone);
    if (!message) {
        if (fallbackOnEmptyString === false && message === '') return message;
        if (!defaultMessage || locale && locale.toLowerCase() !== defaultLocale.toLowerCase()) // This prevents warnings from littering the console in development
        // when no `messages` are passed into the <IntlProvider> for the
        // default locale.
        onError(new (0, $iNgUL.MissingTranslationError)(messageDescriptor, locale));
        if (defaultMessage) try {
            var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
            return formatter.format(values);
        } catch (e) {
            onError(new (0, $iNgUL.MessageFormatError)("Error formatting default message for: \"".concat(id, "\", rendering default message verbatim"), locale, messageDescriptor, e));
            return typeof defaultMessage === 'string' ? defaultMessage : id;
        }
        return id;
    }
    // We have the translated message
    try {
        var formatter = state.getMessageFormat(message, locale, formats, (0, $hXuPC.__assign)({
            formatters: state
        }, opts || {}));
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $iNgUL.MessageFormatError)("Error formatting message: \"".concat(id, "\", using ").concat(defaultMessage ? 'default message' : 'id', " as fallback."), locale, messageDescriptor, e));
    }
    if (defaultMessage) try {
        var formatter = state.getMessageFormat(defaultMessage, defaultLocale, defaultFormats, opts);
        return formatter.format(values);
    } catch (e) {
        onError(new (0, $iNgUL.MessageFormatError)("Error formatting the default message for: \"".concat(id, "\", rendering message verbatim"), locale, messageDescriptor, e));
    }
    if (typeof message === 'string') return message;
    if (typeof defaultMessage === 'string') return defaultMessage;
    return id;
};








var $08f46fcf685210a6$var$NUMBER_FORMAT_OPTIONS = [
    'style',
    'currency',
    'unit',
    'unitDisplay',
    'useGrouping',
    'minimumIntegerDigits',
    'minimumFractionDigits',
    'maximumFractionDigits',
    'minimumSignificantDigits',
    'maximumSignificantDigits',
    // ES2020 NumberFormat
    'compactDisplay',
    'currencyDisplay',
    'currencySign',
    'notation',
    'signDisplay',
    'unit',
    'unitDisplay',
    'numberingSystem',
    // ES2023 NumberFormat
    'trailingZeroDisplay',
    'roundingPriority',
    'roundingIncrement',
    'roundingMode'
];
function $08f46fcf685210a6$export$a7f9565e3c81cd54(_a, getNumberFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = format && (0, $jaEJa.getNamedFormat)(formats, 'number', format, onError) || {};
    var filteredOptions = (0, $jaEJa.filterProps)(options, $08f46fcf685210a6$var$NUMBER_FORMAT_OPTIONS, defaults);
    return getNumberFormat(locale, filteredOptions);
}
function $08f46fcf685210a6$export$f5dd818bff069720(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $08f46fcf685210a6$export$a7f9565e3c81cd54(config, getNumberFormat, options).format(value);
    } catch (e) {
        config.onError(new (0, $iNgUL.IntlFormatError)('Error formatting number.', config.locale, e));
    }
    return String(value);
}
function $08f46fcf685210a6$export$6871080848f10b2f(config, getNumberFormat, value, options) {
    if (options === void 0) options = {};
    try {
        return $08f46fcf685210a6$export$a7f9565e3c81cd54(config, getNumberFormat, options).formatToParts(value);
    } catch (e) {
        config.onError(new (0, $iNgUL.IntlFormatError)('Error formatting number.', config.locale, e));
    }
    return [];
}











var $c8be881b6559b106$var$PLURAL_FORMAT_OPTIONS = [
    'type'
];
function $c8be881b6559b106$export$bbbd05c900f3568d(_a, getPluralRules, value, options) {
    var locale = _a.locale, onError = _a.onError;
    if (options === void 0) options = {};
    if (!Intl.PluralRules) onError(new (0, $1q4lC.FormatError)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $1q4lC.ErrorCode).MISSING_INTL_API));
    var filteredOptions = (0, $jaEJa.filterProps)(options, $c8be881b6559b106$var$PLURAL_FORMAT_OPTIONS);
    try {
        return getPluralRules(locale, filteredOptions).select(value);
    } catch (e) {
        onError(new (0, $iNgUL.IntlFormatError)('Error formatting plural.', locale, e));
    }
    return 'other';
}











var $97f306ae2e320e7c$var$RELATIVE_TIME_FORMAT_OPTIONS = [
    'numeric',
    'style'
];
function $97f306ae2e320e7c$var$getFormatter(_a, getRelativeTimeFormat, options) {
    var locale = _a.locale, formats = _a.formats, onError = _a.onError;
    if (options === void 0) options = {};
    var format = options.format;
    var defaults = !!format && (0, $jaEJa.getNamedFormat)(formats, 'relative', format, onError) || {};
    var filteredOptions = (0, $jaEJa.filterProps)(options, $97f306ae2e320e7c$var$RELATIVE_TIME_FORMAT_OPTIONS, defaults);
    return getRelativeTimeFormat(locale, filteredOptions);
}
function $97f306ae2e320e7c$export$b4ea3b48dcf921f6(config, getRelativeTimeFormat, value, unit, options) {
    if (options === void 0) options = {};
    if (!unit) unit = 'second';
    var RelativeTimeFormat = Intl.RelativeTimeFormat;
    if (!RelativeTimeFormat) config.onError(new (0, $1q4lC.FormatError)("Intl.RelativeTimeFormat is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-relativetimeformat\"\n", (0, $1q4lC.ErrorCode).MISSING_INTL_API));
    try {
        return $97f306ae2e320e7c$var$getFormatter(config, getRelativeTimeFormat, options).format(value, unit);
    } catch (e) {
        config.onError(new (0, $iNgUL.IntlFormatError)('Error formatting relative time.', config.locale, e));
    }
    return String(value);
}





function $24a51aaac1f0ffb6$var$messagesContainString(messages) {
    var firstMessage = messages ? messages[Object.keys(messages)[0]] : undefined;
    return typeof firstMessage === 'string';
}
function $24a51aaac1f0ffb6$var$verifyConfigMessages(config) {
    if (config.onWarn && config.defaultRichTextElements && $24a51aaac1f0ffb6$var$messagesContainString(config.messages || {})) config.onWarn("[@formatjs/intl] \"defaultRichTextElements\" was specified but \"message\" was not pre-compiled. \nPlease consider using \"@formatjs/cli\" to pre-compile your messages for performance.\nFor more details see https://formatjs.github.io/docs/getting-started/message-distribution");
}
function $24a51aaac1f0ffb6$export$7e4cbedfdd7b4c0d(config, cache) {
    var formatters = (0, $jaEJa.createFormatters)(cache);
    var resolvedConfig = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, (0, $jaEJa.DEFAULT_INTL_CONFIG)), config);
    var locale = resolvedConfig.locale, defaultLocale = resolvedConfig.defaultLocale, onError = resolvedConfig.onError;
    if (!locale) {
        if (onError) onError(new (0, $iNgUL.InvalidConfigError)("\"locale\" was not configured, using \"".concat(defaultLocale, "\" as fallback. See https://formatjs.github.io/docs/react-intl/api#intlshape for more details")));
        // Since there's no registered locale data for `locale`, this will
        // fallback to the `defaultLocale` to make sure things can render.
        // The `messages` are overridden to the `defaultProps` empty object
        // to maintain referential equality across re-renders. It's assumed
        // each <FormattedMessage> contains a `defaultMessage` prop.
        resolvedConfig.locale = resolvedConfig.defaultLocale || 'en';
    } else if (!Intl.NumberFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $iNgUL.MissingDataError)("Missing locale data for locale: \"".concat(locale, "\" in Intl.NumberFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.github.io/docs/react-intl#runtime-requirements for more details")));
    else if (!Intl.DateTimeFormat.supportedLocalesOf(locale).length && onError) onError(new (0, $iNgUL.MissingDataError)("Missing locale data for locale: \"".concat(locale, "\" in Intl.DateTimeFormat. Using default locale: \"").concat(defaultLocale, "\" as fallback. See https://formatjs.github.io/docs/react-intl#runtime-requirements for more details")));
    $24a51aaac1f0ffb6$var$verifyConfigMessages(resolvedConfig);
    return (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, resolvedConfig), {
        formatters: formatters,
        formatNumber: (0, $08f46fcf685210a6$export$f5dd818bff069720).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatNumberToParts: (0, $08f46fcf685210a6$export$6871080848f10b2f).bind(null, resolvedConfig, formatters.getNumberFormat),
        formatRelativeTime: (0, $97f306ae2e320e7c$export$b4ea3b48dcf921f6).bind(null, resolvedConfig, formatters.getRelativeTimeFormat),
        formatDate: (0, $70f04aed693068bb$export$3ae94a2503e890a1).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateToParts: (0, $70f04aed693068bb$export$dc1f059bce486b1).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTime: (0, $70f04aed693068bb$export$3203edd9e5edd663).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatDateTimeRange: (0, $70f04aed693068bb$export$a7fc3a91cb2ec376).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatTimeToParts: (0, $70f04aed693068bb$export$af6e5d7a5c73edeb).bind(null, resolvedConfig, formatters.getDateTimeFormat),
        formatPlural: (0, $c8be881b6559b106$export$bbbd05c900f3568d).bind(null, resolvedConfig, formatters.getPluralRules),
        formatMessage: (0, $39fedf17cfaee337$export$25868d1e8e76735f).bind(null, resolvedConfig, formatters),
        $t: (0, $39fedf17cfaee337$export$25868d1e8e76735f).bind(null, resolvedConfig, formatters),
        formatList: (0, $de5667d46d78974d$export$e8b8be48b45905bb).bind(null, resolvedConfig, formatters.getListFormat),
        formatListToParts: (0, $de5667d46d78974d$export$6f284aad1934db69).bind(null, resolvedConfig, formatters.getListFormat),
        formatDisplayName: (0, $584a8e29009be8ab$export$62fe1a4d9e891fa2).bind(null, resolvedConfig, formatters.getDisplayNames)
    });
}



var $38rme = parcelRequire("38rme");


var $gEeFR = parcelRequire("gEeFR");

function $bc9f24e3bb537c84$var$assignUniqueKeysToFormatXMLElementFnArgument(values) {
    if (!values) return values;
    return Object.keys(values).reduce(function(acc, k) {
        var v = values[k];
        acc[k] = (0, $38rme.isFormatXMLElementFn)(v) ? (0, $gEeFR.assignUniqueKeysToParts)(v) : v;
        return acc;
    }, {});
}
var $bc9f24e3bb537c84$var$formatMessage = function(config, formatters, descriptor, rawValues) {
    var rest = [];
    for(var _i = 4; _i < arguments.length; _i++)rest[_i - 4] = arguments[_i];
    var values = $bc9f24e3bb537c84$var$assignUniqueKeysToFormatXMLElementFnArgument(rawValues);
    var chunks = (0, $39fedf17cfaee337$export$25868d1e8e76735f).apply(void 0, (0, $hXuPC.__spreadArray)([
        config,
        formatters,
        descriptor,
        values
    ], rest, false));
    if (Array.isArray(chunks)) return (0, $gEeFR.toKeyedReactNodeArray)(chunks);
    return chunks;
};
var $bc9f24e3bb537c84$export$7e4cbedfdd7b4c0d = function(_a, cache) {
    var rawDefaultRichTextElements = _a.defaultRichTextElements, config = (0, $hXuPC.__rest)(_a, [
        "defaultRichTextElements"
    ]);
    var defaultRichTextElements = $bc9f24e3bb537c84$var$assignUniqueKeysToFormatXMLElementFnArgument(rawDefaultRichTextElements);
    var coreIntl = (0, $24a51aaac1f0ffb6$export$7e4cbedfdd7b4c0d)((0, $hXuPC.__assign)((0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, (0, $gEeFR.DEFAULT_INTL_CONFIG)), config), {
        defaultRichTextElements: defaultRichTextElements
    }), cache);
    var resolvedConfig = {
        locale: coreIntl.locale,
        timeZone: coreIntl.timeZone,
        fallbackOnEmptyString: coreIntl.fallbackOnEmptyString,
        formats: coreIntl.formats,
        defaultLocale: coreIntl.defaultLocale,
        defaultFormats: coreIntl.defaultFormats,
        messages: coreIntl.messages,
        onError: coreIntl.onError,
        defaultRichTextElements: defaultRichTextElements
    };
    return (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, coreIntl), {
        formatMessage: $bc9f24e3bb537c84$var$formatMessage.bind(null, resolvedConfig, coreIntl.formatters),
        $t: $bc9f24e3bb537c84$var$formatMessage.bind(null, resolvedConfig, coreIntl.formatters)
    });
};
module.exports["createIntl"] = $bc9f24e3bb537c84$export$7e4cbedfdd7b4c0d;

});

parcelRegister("hiS1z", function(module, exports) {
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $hXuPC = parcelRequire("hXuPC");


var $42omo = parcelRequire("42omo");


var $gEeFR = parcelRequire("gEeFR");


var $1cfRh = parcelRequire("1cfRh");

function $c98e0636ac708d3b$var$areEqual(prevProps, nextProps) {
    var values = prevProps.values, otherProps = (0, $hXuPC.__rest)(prevProps, [
        "values"
    ]);
    var nextValues = nextProps.values, nextOtherProps = (0, $hXuPC.__rest)(nextProps, [
        "values"
    ]);
    return (0, $gEeFR.shallowEqual)(nextValues, values) && (0, $gEeFR.shallowEqual)(otherProps, nextOtherProps);
}
function $c98e0636ac708d3b$var$FormattedMessage(props) {
    var intl = (0, $1cfRh.default)();
    var formatMessage = intl.formatMessage, _a = intl.textComponent, Text = _a === void 0 ? $42omo.Fragment : _a;
    var id = props.id, description = props.description, defaultMessage = props.defaultMessage, values = props.values, children = props.children, _b = props.tagName, Component = _b === void 0 ? Text : _b, ignoreTag = props.ignoreTag;
    var descriptor = {
        id: id,
        description: description,
        defaultMessage: defaultMessage
    };
    var nodes = formatMessage(descriptor, values, {
        ignoreTag: ignoreTag
    });
    if (typeof children === 'function') return children(Array.isArray(nodes) ? nodes : [
        nodes
    ]);
    if (Component) return $42omo.createElement(Component, null, nodes);
    return $42omo.createElement($42omo.Fragment, null, nodes);
}
$c98e0636ac708d3b$var$FormattedMessage.displayName = 'FormattedMessage';
var $c98e0636ac708d3b$var$MemoizedFormattedMessage = $42omo.memo($c98e0636ac708d3b$var$FormattedMessage, $c98e0636ac708d3b$var$areEqual);
$c98e0636ac708d3b$var$MemoizedFormattedMessage.displayName = 'MemoizedFormattedMessage';
var $c98e0636ac708d3b$export$2e2bcd8739ae039 = $c98e0636ac708d3b$var$MemoizedFormattedMessage;
module.exports["default"] = $c98e0636ac708d3b$export$2e2bcd8739ae039;

});

parcelRegister("30lHU", function(module, exports) {
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $hXuPC = parcelRequire("hXuPC");


var $jaEJa = parcelRequire("jaEJa");


var $42omo = parcelRequire("42omo");


var $gEeFR = parcelRequire("gEeFR");


var $gc1M8 = parcelRequire("gc1M8");


var $cs1vW = parcelRequire("cs1vW");

function $230235c94124a7ab$var$processIntlConfig(config) {
    return {
        locale: config.locale,
        timeZone: config.timeZone,
        fallbackOnEmptyString: config.fallbackOnEmptyString,
        formats: config.formats,
        textComponent: config.textComponent,
        messages: config.messages,
        defaultLocale: config.defaultLocale,
        defaultFormats: config.defaultFormats,
        onError: config.onError,
        onWarn: config.onWarn,
        wrapRichTextChunksInFragment: config.wrapRichTextChunksInFragment,
        defaultRichTextElements: config.defaultRichTextElements
    };
}
var $230235c94124a7ab$var$IntlProvider = /** @class */ function(_super) {
    (0, $hXuPC.__extends)(IntlProvider, _super);
    function IntlProvider() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.cache = (0, $jaEJa.createIntlCache)();
        _this.state = {
            cache: _this.cache,
            intl: (0, $gc1M8.createIntl)($230235c94124a7ab$var$processIntlConfig(_this.props), _this.cache),
            prevConfig: $230235c94124a7ab$var$processIntlConfig(_this.props)
        };
        return _this;
    }
    IntlProvider.getDerivedStateFromProps = function(props, _a) {
        var prevConfig = _a.prevConfig, cache = _a.cache;
        var config = $230235c94124a7ab$var$processIntlConfig(props);
        if (!(0, $gEeFR.shallowEqual)(prevConfig, config)) return {
            intl: (0, $gc1M8.createIntl)(config, cache),
            prevConfig: config
        };
        return null;
    };
    IntlProvider.prototype.render = function() {
        (0, $gEeFR.invariantIntlContext)(this.state.intl);
        return $42omo.createElement((0, $cs1vW.Provider), {
            value: this.state.intl
        }, this.props.children);
    };
    IntlProvider.displayName = 'IntlProvider';
    IntlProvider.defaultProps = (0, $gEeFR.DEFAULT_INTL_CONFIG);
    return IntlProvider;
}($42omo.PureComponent);
var $230235c94124a7ab$export$2e2bcd8739ae039 = $230235c94124a7ab$var$IntlProvider;
module.exports["default"] = $230235c94124a7ab$export$2e2bcd8739ae039;

});

parcelRegister("lD0Co", function(module, exports) {

var $hXuPC = parcelRequire("hXuPC");


var $42omo = parcelRequire("42omo");


var $gEeFR = parcelRequire("gEeFR");


var $1cfRh = parcelRequire("1cfRh");

var $fbedb845945b56c1$var$MINUTE = 60;
var $fbedb845945b56c1$var$HOUR = 3600;
var $fbedb845945b56c1$var$DAY = 86400;
function $fbedb845945b56c1$var$selectUnit(seconds) {
    var absValue = Math.abs(seconds);
    if (absValue < $fbedb845945b56c1$var$MINUTE) return 'second';
    if (absValue < $fbedb845945b56c1$var$HOUR) return 'minute';
    if (absValue < $fbedb845945b56c1$var$DAY) return 'hour';
    return 'day';
}
function $fbedb845945b56c1$var$getDurationInSeconds(unit) {
    switch(unit){
        case 'second':
            return 1;
        case 'minute':
            return $fbedb845945b56c1$var$MINUTE;
        case 'hour':
            return $fbedb845945b56c1$var$HOUR;
        default:
            return $fbedb845945b56c1$var$DAY;
    }
}
function $fbedb845945b56c1$var$valueToSeconds(value, unit) {
    if (!value) return 0;
    switch(unit){
        case 'second':
            return value;
        case 'minute':
            return value * $fbedb845945b56c1$var$MINUTE;
        default:
            return value * $fbedb845945b56c1$var$HOUR;
    }
}
var $fbedb845945b56c1$var$INCREMENTABLE_UNITS = [
    'second',
    'minute',
    'hour'
];
function $fbedb845945b56c1$var$canIncrement(unit) {
    if (unit === void 0) unit = 'second';
    return $fbedb845945b56c1$var$INCREMENTABLE_UNITS.indexOf(unit) > -1;
}
var $fbedb845945b56c1$var$SimpleFormattedRelativeTime = function(props) {
    var _a = (0, $1cfRh.default)(), formatRelativeTime = _a.formatRelativeTime, Text = _a.textComponent;
    var children = props.children, value = props.value, unit = props.unit, otherProps = (0, $hXuPC.__rest)(props, [
        "children",
        "value",
        "unit"
    ]);
    var formattedRelativeTime = formatRelativeTime(value || 0, unit, otherProps);
    if (typeof children === 'function') return children(formattedRelativeTime);
    if (Text) return $42omo.createElement(Text, null, formattedRelativeTime);
    return $42omo.createElement($42omo.Fragment, null, formattedRelativeTime);
};
var $fbedb845945b56c1$var$FormattedRelativeTime = function(_a) {
    var _b = _a.value, value = _b === void 0 ? 0 : _b, _c = _a.unit, unit = _c === void 0 ? 'second' : _c, updateIntervalInSeconds = _a.updateIntervalInSeconds, otherProps = (0, $hXuPC.__rest)(_a, [
        "value",
        "unit",
        "updateIntervalInSeconds"
    ]);
    (0, $gEeFR.invariant)(!updateIntervalInSeconds || !!(updateIntervalInSeconds && $fbedb845945b56c1$var$canIncrement(unit)), 'Cannot schedule update with unit longer than hour');
    var _d = $42omo.useState(), prevUnit = _d[0], setPrevUnit = _d[1];
    var _e = $42omo.useState(0), prevValue = _e[0], setPrevValue = _e[1];
    var _f = $42omo.useState(0), currentValueInSeconds = _f[0], setCurrentValueInSeconds = _f[1];
    var updateTimer;
    if (unit !== prevUnit || value !== prevValue) {
        setPrevValue(value || 0);
        setPrevUnit(unit);
        setCurrentValueInSeconds($fbedb845945b56c1$var$canIncrement(unit) ? $fbedb845945b56c1$var$valueToSeconds(value, unit) : 0);
    }
    $42omo.useEffect(function() {
        function clearUpdateTimer() {
            clearTimeout(updateTimer);
        }
        clearUpdateTimer();
        // If there's no interval and we cannot increment this unit, do nothing
        if (!updateIntervalInSeconds || !$fbedb845945b56c1$var$canIncrement(unit)) return clearUpdateTimer;
        // Figure out the next interesting time
        var nextValueInSeconds = currentValueInSeconds - updateIntervalInSeconds;
        var nextUnit = $fbedb845945b56c1$var$selectUnit(nextValueInSeconds);
        // We've reached the max auto incrementable unit, don't schedule another update
        if (nextUnit === 'day') return clearUpdateTimer;
        var unitDuration = $fbedb845945b56c1$var$getDurationInSeconds(nextUnit);
        var remainder = nextValueInSeconds % unitDuration;
        var prevInterestingValueInSeconds = nextValueInSeconds - remainder;
        var nextInterestingValueInSeconds = prevInterestingValueInSeconds >= currentValueInSeconds ? prevInterestingValueInSeconds - unitDuration : prevInterestingValueInSeconds;
        var delayInSeconds = Math.abs(nextInterestingValueInSeconds - currentValueInSeconds);
        if (currentValueInSeconds !== nextInterestingValueInSeconds) updateTimer = setTimeout(function() {
            return setCurrentValueInSeconds(nextInterestingValueInSeconds);
        }, delayInSeconds * 1e3);
        return clearUpdateTimer;
    }, [
        currentValueInSeconds,
        updateIntervalInSeconds,
        unit
    ]);
    var currentValue = value || 0;
    var currentUnit = unit;
    if ($fbedb845945b56c1$var$canIncrement(unit) && typeof currentValueInSeconds === 'number' && updateIntervalInSeconds) {
        currentUnit = $fbedb845945b56c1$var$selectUnit(currentValueInSeconds);
        var unitDuration = $fbedb845945b56c1$var$getDurationInSeconds(currentUnit);
        currentValue = Math.round(currentValueInSeconds / unitDuration);
    }
    return $42omo.createElement($fbedb845945b56c1$var$SimpleFormattedRelativeTime, (0, $hXuPC.__assign)({
        value: currentValue,
        unit: currentUnit
    }, otherProps));
};
$fbedb845945b56c1$var$FormattedRelativeTime.displayName = 'FormattedRelativeTime';
var $fbedb845945b56c1$export$2e2bcd8739ae039 = $fbedb845945b56c1$var$FormattedRelativeTime;
module.exports["default"] = $fbedb845945b56c1$export$2e2bcd8739ae039;

});

parcelRegister("9HkI0", function(module, exports) {
var $11a26bbb19c50c31$exports = {};

var $awSkB = parcelRequire("awSkB");


var $aYYGS = parcelRequire("aYYGS");

// **`v1()` - Generate time-based UUID**
//
// Inspired by https://github.com/LiosK/UUID.js
// and http://docs.python.org/library/uuid.html
var $11a26bbb19c50c31$var$_nodeId;
var $11a26bbb19c50c31$var$_clockseq;
// Previous uuid creation time
var $11a26bbb19c50c31$var$_lastMSecs = 0;
var $11a26bbb19c50c31$var$_lastNSecs = 0;
// See https://github.com/uuidjs/uuid for API details
function $11a26bbb19c50c31$var$v1(options, buf, offset) {
    var i = buf && offset || 0;
    var b = buf || [];
    options = options || {};
    var node = options.node || $11a26bbb19c50c31$var$_nodeId;
    var clockseq = options.clockseq !== undefined ? options.clockseq : $11a26bbb19c50c31$var$_clockseq;
    // node and clockseq need to be initialized to random values if they're not
    // specified.  We do this lazily to minimize issues related to insufficient
    // system entropy.  See #189
    if (node == null || clockseq == null) {
        var seedBytes = $awSkB();
        if (node == null) // Per 4.5, create and 48-bit node id, (47 random bits + multicast bit = 1)
        node = $11a26bbb19c50c31$var$_nodeId = [
            seedBytes[0] | 0x01,
            seedBytes[1],
            seedBytes[2],
            seedBytes[3],
            seedBytes[4],
            seedBytes[5]
        ];
        if (clockseq == null) // Per 4.2.2, randomize (14 bit) clockseq
        clockseq = $11a26bbb19c50c31$var$_clockseq = (seedBytes[6] << 8 | seedBytes[7]) & 0x3fff;
    }
    // UUID timestamps are 100 nano-second units since the Gregorian epoch,
    // (1582-10-15 00:00).  JSNumbers aren't precise enough for this, so
    // time is handled internally as 'msecs' (integer milliseconds) and 'nsecs'
    // (100-nanoseconds offset from msecs) since unix epoch, 1970-01-01 00:00.
    var msecs = options.msecs !== undefined ? options.msecs : new Date().getTime();
    // Per 4.2.1.2, use count of uuid's generated during the current clock
    // cycle to simulate higher resolution clock
    var nsecs = options.nsecs !== undefined ? options.nsecs : $11a26bbb19c50c31$var$_lastNSecs + 1;
    // Time since last uuid creation (in msecs)
    var dt = msecs - $11a26bbb19c50c31$var$_lastMSecs + (nsecs - $11a26bbb19c50c31$var$_lastNSecs) / 10000;
    // Per 4.2.1.2, Bump clockseq on clock regression
    if (dt < 0 && options.clockseq === undefined) clockseq = clockseq + 1 & 0x3fff;
    // Reset nsecs if clock regresses (new clockseq) or we've moved onto a new
    // time interval
    if ((dt < 0 || msecs > $11a26bbb19c50c31$var$_lastMSecs) && options.nsecs === undefined) nsecs = 0;
    // Per 4.2.1.2 Throw error if too many uuids are requested
    if (nsecs >= 10000) throw new Error('uuid.v1(): Can\'t create more than 10M uuids/sec');
    $11a26bbb19c50c31$var$_lastMSecs = msecs;
    $11a26bbb19c50c31$var$_lastNSecs = nsecs;
    $11a26bbb19c50c31$var$_clockseq = clockseq;
    // Per 4.1.4 - Convert from unix epoch to Gregorian epoch
    msecs += 12219292800000;
    // `time_low`
    var tl = ((msecs & 0xfffffff) * 10000 + nsecs) % 0x100000000;
    b[i++] = tl >>> 24 & 0xff;
    b[i++] = tl >>> 16 & 0xff;
    b[i++] = tl >>> 8 & 0xff;
    b[i++] = tl & 0xff;
    // `time_mid`
    var tmh = msecs / 0x100000000 * 10000 & 0xfffffff;
    b[i++] = tmh >>> 8 & 0xff;
    b[i++] = tmh & 0xff;
    // `time_high_and_version`
    b[i++] = tmh >>> 24 & 0xf | 0x10; // include version
    b[i++] = tmh >>> 16 & 0xff;
    // `clock_seq_hi_and_reserved` (Per 4.2.2 - include variant)
    b[i++] = clockseq >>> 8 | 0x80;
    // `clock_seq_low`
    b[i++] = clockseq & 0xff;
    // `node`
    for(var n = 0; n < 6; ++n)b[i + n] = node[n];
    return buf ? buf : $aYYGS(b);
}
$11a26bbb19c50c31$exports = $11a26bbb19c50c31$var$v1;



var $kyKWe = parcelRequire("kyKWe");

var $70f83188ef1bd34f$var$uuid = $kyKWe;
$70f83188ef1bd34f$var$uuid.v1 = $11a26bbb19c50c31$exports;
$70f83188ef1bd34f$var$uuid.v4 = $kyKWe;
module.exports = $70f83188ef1bd34f$var$uuid;

});

parcelRegister("kyKWe", function(module, exports) {

var $awSkB = parcelRequire("awSkB");


var $aYYGS = parcelRequire("aYYGS");

function $ef7b6490dc24dd32$var$v4(options, buf, offset) {
    var i = buf && offset || 0;
    if (typeof options == 'string') {
        buf = options === 'binary' ? new Array(16) : null;
        options = null;
    }
    options = options || {};
    var rnds = options.random || (options.rng || $awSkB)();
    // Per 4.4, set bits for version and `clock_seq_hi_and_reserved`
    rnds[6] = rnds[6] & 0x0f | 0x40;
    rnds[8] = rnds[8] & 0x3f | 0x80;
    // Copy bytes to buffer, if provided
    if (buf) for(var ii = 0; ii < 16; ++ii)buf[i + ii] = rnds[ii];
    return buf || $aYYGS(rnds);
}
module.exports = $ef7b6490dc24dd32$var$v4;

});

parcelRegister("fvqz5", function(module, exports) {
/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $b49e5b83abcdd205$var$warning = function() {};
module.exports = $b49e5b83abcdd205$var$warning;

});

parcelRegister("bKqeQ", function(module, exports) {

var $6acb5 = parcelRequire("6acb5");


var $dsvEp = parcelRequire("dsvEp");

function $88d858015cfbe7a1$export$5d730b7aed1a3eb0(options) {
    const { url: url, connectionParams: connectionParams, lazy: lazy = true, onNonLazyError: onNonLazyError = console.error, lazyCloseTimeout: lazyCloseTimeoutMs = 0, keepAlive: keepAlive = 0, disablePong: disablePong, connectionAckWaitTimeout: connectionAckWaitTimeout = 0, retryAttempts: retryAttempts = 5, retryWait: retryWait = async function randomisedExponentialBackoff(retries2) {
        const retryDelaySeconds = Math.pow(2, retries2);
        await new Promise((resolve)=>setTimeout(resolve, retryDelaySeconds * 1e3 + // add random timeout from 300ms to 3s
            Math.floor(Math.random() * 2700 + 300)));
    }, shouldRetry: shouldRetry = $88d858015cfbe7a1$var$isLikeCloseEvent, on: on, webSocketImpl: webSocketImpl, generateID: /**
     * Generates a v4 UUID to be used as the ID using `Math`
     * as the random number generator. Supply your own generator
     * in case you need more uniqueness.
     *
     * Reference: https://gist.github.com/jed/982883
     */ generateID = function generateUUID() {
        return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (c)=>{
            const r = Math.random() * 16 | 0, v = c == "x" ? r : r & 3 | 8;
            return v.toString(16);
        });
    }, jsonMessageReplacer: replacer, jsonMessageReviver: reviver } = options;
    let ws;
    if (webSocketImpl) {
        if (!$88d858015cfbe7a1$var$isWebSocket(webSocketImpl)) throw new Error("Invalid WebSocket implementation provided");
        ws = webSocketImpl;
    } else if (typeof WebSocket !== "undefined") ws = WebSocket;
    else if (typeof $parcel$global !== "undefined") ws = $parcel$global.WebSocket || // @ts-expect-error: Support more browsers
    $parcel$global.MozWebSocket;
    else if (typeof window !== "undefined") ws = window.WebSocket || // @ts-expect-error: Support more browsers
    window.MozWebSocket;
    if (!ws) throw new Error("WebSocket implementation missing; on Node you can `import WebSocket from 'ws';` and pass `webSocketImpl: WebSocket` to `createClient`");
    const WebSocketImpl = ws;
    const emitter = (()=>{
        const message = /* @__PURE__ */ (()=>{
            const listeners2 = {};
            return {
                on (id, listener) {
                    listeners2[id] = listener;
                    return ()=>{
                        delete listeners2[id];
                    };
                },
                emit (message2) {
                    if ("id" in message2) listeners2[message2.id]?.(message2);
                }
            };
        })();
        const listeners = {
            connecting: on?.connecting ? [
                on.connecting
            ] : [],
            opened: on?.opened ? [
                on.opened
            ] : [],
            connected: on?.connected ? [
                on.connected
            ] : [],
            ping: on?.ping ? [
                on.ping
            ] : [],
            pong: on?.pong ? [
                on.pong
            ] : [],
            message: on?.message ? [
                message.emit,
                on.message
            ] : [
                message.emit
            ],
            closed: on?.closed ? [
                on.closed
            ] : [],
            error: on?.error ? [
                on.error
            ] : []
        };
        return {
            onMessage: message.on,
            on (event, listener) {
                const l = listeners[event];
                l.push(listener);
                return ()=>{
                    l.splice(l.indexOf(listener), 1);
                };
            },
            emit (event, ...args) {
                for (const listener of [
                    ...listeners[event]
                ])listener(...args);
            }
        };
    })();
    function errorOrClosed(cb) {
        const listening = [
            // errors are fatal and more critical than close events, throw them first
            emitter.on("error", (err)=>{
                listening.forEach((unlisten)=>unlisten());
                cb(err);
            }),
            // closes can be graceful and not fatal, throw them second (if error didnt throw)
            emitter.on("closed", (event)=>{
                listening.forEach((unlisten)=>unlisten());
                cb(event);
            })
        ];
    }
    let connecting, locks = 0, lazyCloseTimeout, retrying = false, retries = 0, disposed = false;
    async function connect() {
        clearTimeout(lazyCloseTimeout);
        const [socket, throwOnClose] = await (connecting ?? (connecting = new Promise((connected, denied)=>(async ()=>{
                if (retrying) {
                    await retryWait(retries);
                    if (!locks) {
                        connecting = void 0;
                        return denied({
                            code: 1e3,
                            reason: "All Subscriptions Gone"
                        });
                    }
                    retries++;
                }
                emitter.emit("connecting", retrying);
                const socket2 = new WebSocketImpl(typeof url === "function" ? await url() : url, (0, $dsvEp.G));
                let connectionAckTimeout, queuedPing;
                function enqueuePing() {
                    if (isFinite(keepAlive) && keepAlive > 0) {
                        clearTimeout(queuedPing);
                        queuedPing = setTimeout(()=>{
                            if (socket2.readyState === WebSocketImpl.OPEN) {
                                socket2.send((0, $dsvEp.s)({
                                    type: (0, $dsvEp.M).Ping
                                }));
                                emitter.emit("ping", false, void 0);
                            }
                        }, keepAlive);
                    }
                }
                errorOrClosed((errOrEvent)=>{
                    connecting = void 0;
                    clearTimeout(connectionAckTimeout);
                    clearTimeout(queuedPing);
                    denied(errOrEvent);
                    if (errOrEvent instanceof $88d858015cfbe7a1$export$f5b1bfead8e118a7) {
                        socket2.close(4499, "Terminated");
                        socket2.onerror = null;
                        socket2.onclose = null;
                    }
                });
                socket2.onerror = (err)=>emitter.emit("error", err);
                socket2.onclose = (event)=>emitter.emit("closed", event);
                socket2.onopen = async ()=>{
                    try {
                        emitter.emit("opened", socket2);
                        const payload = typeof connectionParams === "function" ? await connectionParams() : connectionParams;
                        if (socket2.readyState !== WebSocketImpl.OPEN) return;
                        socket2.send((0, $dsvEp.s)(payload ? {
                            type: (0, $dsvEp.M).ConnectionInit,
                            payload: payload
                        } : {
                            type: (0, $dsvEp.M).ConnectionInit
                        }, replacer));
                        if (isFinite(connectionAckWaitTimeout) && connectionAckWaitTimeout > 0) connectionAckTimeout = setTimeout(()=>{
                            socket2.close((0, $dsvEp.C).ConnectionAcknowledgementTimeout, "Connection acknowledgement timeout");
                        }, connectionAckWaitTimeout);
                        enqueuePing();
                    } catch (err) {
                        emitter.emit("error", err);
                        socket2.close((0, $dsvEp.C).InternalClientError, (0, $dsvEp.l)(err instanceof Error ? err.message : String(err), "Internal client error"));
                    }
                };
                let acknowledged = false;
                socket2.onmessage = ({ data: data })=>{
                    try {
                        const message = (0, $dsvEp.p)(data, reviver);
                        emitter.emit("message", message);
                        if (message.type === "ping" || message.type === "pong") {
                            emitter.emit(message.type, true, message.payload);
                            if (message.type === "pong") enqueuePing();
                            else if (!disablePong) {
                                socket2.send((0, $dsvEp.s)(message.payload ? {
                                    type: (0, $dsvEp.M).Pong,
                                    payload: message.payload
                                } : {
                                    type: (0, $dsvEp.M).Pong
                                }));
                                emitter.emit("pong", false, message.payload);
                            }
                            return;
                        }
                        if (acknowledged) return;
                        if (message.type !== (0, $dsvEp.M).ConnectionAck) throw new Error(`First message cannot be of type ${message.type}`);
                        clearTimeout(connectionAckTimeout);
                        acknowledged = true;
                        emitter.emit("connected", socket2, message.payload, retrying);
                        retrying = false;
                        retries = 0;
                        connected([
                            socket2,
                            new Promise((_, reject)=>errorOrClosed(reject))
                        ]);
                    } catch (err) {
                        socket2.onmessage = null;
                        emitter.emit("error", err);
                        socket2.close((0, $dsvEp.C).BadResponse, (0, $dsvEp.l)(err instanceof Error ? err.message : String(err), "Bad response"));
                    }
                };
            })())));
        if (socket.readyState === WebSocketImpl.CLOSING) await throwOnClose;
        let release = ()=>{};
        const released = new Promise((resolve)=>release = resolve);
        return [
            socket,
            release,
            Promise.race([
                // wait for
                released.then(()=>{
                    if (!locks) {
                        const complete = ()=>socket.close(1e3, "Normal Closure");
                        if (isFinite(lazyCloseTimeoutMs) && lazyCloseTimeoutMs > 0) lazyCloseTimeout = setTimeout(()=>{
                            if (socket.readyState === WebSocketImpl.OPEN) complete();
                        }, lazyCloseTimeoutMs);
                        else complete();
                    }
                }),
                // or
                throwOnClose
            ])
        ];
    }
    function shouldRetryConnectOrThrow(errOrCloseEvent) {
        if ($88d858015cfbe7a1$var$isLikeCloseEvent(errOrCloseEvent) && ($88d858015cfbe7a1$var$isFatalInternalCloseCode(errOrCloseEvent.code) || [
            (0, $dsvEp.C).InternalServerError,
            (0, $dsvEp.C).InternalClientError,
            (0, $dsvEp.C).BadRequest,
            (0, $dsvEp.C).BadResponse,
            (0, $dsvEp.C).Unauthorized,
            // CloseCode.Forbidden, might grant access out after retry
            (0, $dsvEp.C).SubprotocolNotAcceptable,
            // CloseCode.ConnectionInitialisationTimeout, might not time out after retry
            // CloseCode.ConnectionAcknowledgementTimeout, might not time out after retry
            (0, $dsvEp.C).SubscriberAlreadyExists,
            (0, $dsvEp.C).TooManyInitialisationRequests
        ].includes(errOrCloseEvent.code))) throw errOrCloseEvent;
        if (disposed) return false;
        if ($88d858015cfbe7a1$var$isLikeCloseEvent(errOrCloseEvent) && errOrCloseEvent.code === 1e3) return locks > 0;
        if (!retryAttempts || retries >= retryAttempts) throw errOrCloseEvent;
        if (!shouldRetry(errOrCloseEvent)) throw errOrCloseEvent;
        return retrying = true;
    }
    if (!lazy) (async ()=>{
        locks++;
        for(;;)try {
            const [, , throwOnClose] = await connect();
            await throwOnClose;
        } catch (errOrCloseEvent) {
            try {
                if (!shouldRetryConnectOrThrow(errOrCloseEvent)) return;
            } catch (errOrCloseEvent2) {
                return onNonLazyError?.(errOrCloseEvent2);
            }
        }
    })();
    function subscribe(payload, sink) {
        const id = generateID(payload);
        let done = false, errored = false, releaser = ()=>{
            locks--;
            done = true;
        };
        (async ()=>{
            locks++;
            for(;;)try {
                const [socket, release, waitForReleaseOrThrowOnClose] = await connect();
                if (done) return release();
                const unlisten = emitter.onMessage(id, (message)=>{
                    switch(message.type){
                        case (0, $dsvEp.M).Next:
                            sink.next(message.payload);
                            return;
                        case (0, $dsvEp.M).Error:
                            errored = true, done = true;
                            sink.error(message.payload);
                            releaser();
                            return;
                        case (0, $dsvEp.M).Complete:
                            done = true;
                            releaser();
                            return;
                    }
                });
                socket.send((0, $dsvEp.s)({
                    id: id,
                    type: (0, $dsvEp.M).Subscribe,
                    payload: payload
                }, replacer));
                releaser = ()=>{
                    if (!done && socket.readyState === WebSocketImpl.OPEN) socket.send((0, $dsvEp.s)({
                        id: id,
                        type: (0, $dsvEp.M).Complete
                    }, replacer));
                    locks--;
                    done = true;
                    release();
                };
                await waitForReleaseOrThrowOnClose.finally(unlisten);
                return;
            } catch (errOrCloseEvent) {
                if (!shouldRetryConnectOrThrow(errOrCloseEvent)) return;
            }
        })().then(()=>{
            if (!errored) sink.complete();
        }).catch((err)=>{
            sink.error(err);
        });
        return ()=>{
            if (!done) releaser();
        };
    }
    return {
        on: emitter.on,
        subscribe: subscribe,
        iterate (request) {
            const pending = [];
            const deferred = {
                done: false,
                error: null,
                resolve: ()=>{}
            };
            const dispose = subscribe(request, {
                next (val) {
                    pending.push(val);
                    deferred.resolve();
                },
                error (err) {
                    deferred.done = true;
                    deferred.error = err;
                    deferred.resolve();
                },
                complete () {
                    deferred.done = true;
                    deferred.resolve();
                }
            });
            const iterator = async function* iterator2() {
                for(;;){
                    if (!pending.length) await new Promise((resolve)=>deferred.resolve = resolve);
                    while(pending.length)yield pending.shift();
                    if (deferred.error) throw deferred.error;
                    if (deferred.done) return;
                }
            }();
            iterator.throw = async (err)=>{
                if (!deferred.done) {
                    deferred.done = true;
                    deferred.error = err;
                    deferred.resolve();
                }
                return {
                    done: true,
                    value: void 0
                };
            };
            iterator.return = async ()=>{
                dispose();
                return {
                    done: true,
                    value: void 0
                };
            };
            return iterator;
        },
        async dispose () {
            disposed = true;
            if (connecting) {
                const [socket] = await connecting;
                socket.close(1e3, "Normal Closure");
            }
        },
        terminate () {
            if (connecting) emitter.emit("closed", new $88d858015cfbe7a1$export$f5b1bfead8e118a7());
        }
    };
}
class $88d858015cfbe7a1$export$f5b1bfead8e118a7 extends Error {
    constructor(...args){
        super(...args), (0, $6acb5._)(this, "name", "TerminatedCloseEvent"), (0, $6acb5._)(this, "message", "4499: Terminated"), (0, $6acb5._)(this, "code", 4499), (0, $6acb5._)(this, "reason", "Terminated"), (0, $6acb5._)(this, "wasClean", false);
    }
}
function $88d858015cfbe7a1$var$isLikeCloseEvent(val) {
    return (0, $dsvEp.i)(val) && "code" in val && "reason" in val;
}
function $88d858015cfbe7a1$var$isFatalInternalCloseCode(code) {
    if ([
        1e3,
        // Normal Closure is not an erroneous close code
        1001,
        // Going Away
        1006,
        // Abnormal Closure
        1005,
        // No Status Received
        1012,
        // Service Restart
        1013,
        // Try Again Later
        1014
    ].includes(code)) return false;
    return code >= 1e3 && code <= 1999;
}
function $88d858015cfbe7a1$var$isWebSocket(val) {
    return typeof val === "function" && "constructor" in val && "CLOSED" in val && "CLOSING" in val && "CONNECTING" in val && "OPEN" in val;
}
module.exports["createClient"] = $88d858015cfbe7a1$export$5d730b7aed1a3eb0;

});

parcelRegister("8aej1", function(module, exports) {

var $kJOOQ = parcelRequire("kJOOQ");

function $5f1a5abef19d6af7$var$_toConsumableArray(arr) {
    return $5f1a5abef19d6af7$var$_arrayWithoutHoles(arr) || $5f1a5abef19d6af7$var$_iterableToArray(arr) || $5f1a5abef19d6af7$var$_unsupportedIterableToArray(arr) || $5f1a5abef19d6af7$var$_nonIterableSpread();
}
function $5f1a5abef19d6af7$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $5f1a5abef19d6af7$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $5f1a5abef19d6af7$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $5f1a5abef19d6af7$var$_arrayLikeToArray(o, minLen);
}
function $5f1a5abef19d6af7$var$_iterableToArray(iter) {
    if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}
function $5f1a5abef19d6af7$var$_arrayWithoutHoles(arr) {
    if (Array.isArray(arr)) return $5f1a5abef19d6af7$var$_arrayLikeToArray(arr);
}
function $5f1a5abef19d6af7$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
/**
 * This middleware captures CALL_HISTORY_METHOD actions to redirect to the
 * provided history object. This will prevent these actions from reaching your
 * reducer or any middleware that comes after this one.
 */ var $5f1a5abef19d6af7$var$routerMiddleware = function routerMiddleware(history) {
    return function(store) {
        return function(next) {
            return function(action) {
                // eslint-disable-line no-unused-vars
                if (action.type !== (0, $kJOOQ.CALL_HISTORY_METHOD)) return next(action);
                var _action$payload = action.payload, method = _action$payload.method, args = _action$payload.args;
                history[method].apply(history, $5f1a5abef19d6af7$var$_toConsumableArray(args));
            };
        };
    };
};
var $5f1a5abef19d6af7$export$2e2bcd8739ae039 = $5f1a5abef19d6af7$var$routerMiddleware;
module.exports["default"] = $5f1a5abef19d6af7$export$2e2bcd8739ae039;

});

parcelRegister("kJOOQ", function(module, exports) {
/**
 * This action type will be dispatched when your history
 * receives a location change.
 */ var $f18f6e3856e45eb6$export$be84bd1ba815d4c2 = '@@router/LOCATION_CHANGE';
var $f18f6e3856e45eb6$export$924382de27029fe1 = function onLocationChanged(location, action) {
    var isFirstRendering = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    return {
        type: $f18f6e3856e45eb6$export$be84bd1ba815d4c2,
        payload: {
            location: location,
            action: action,
            isFirstRendering: isFirstRendering
        }
    };
};
var $f18f6e3856e45eb6$export$d035cdafa5d37a89 = '@@router/CALL_HISTORY_METHOD';
var $f18f6e3856e45eb6$var$updateLocation = function updateLocation(method) {
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        return {
            type: $f18f6e3856e45eb6$export$d035cdafa5d37a89,
            payload: {
                method: method,
                args: args
            }
        };
    };
};
var $f18f6e3856e45eb6$export$4cbf152802aa238 = $f18f6e3856e45eb6$var$updateLocation('push');
var $f18f6e3856e45eb6$export$77ad94ebf1c2b9ed = $f18f6e3856e45eb6$var$updateLocation('replace');
var $f18f6e3856e45eb6$export$93bb224d05b3906d = $f18f6e3856e45eb6$var$updateLocation('go');
var $f18f6e3856e45eb6$export$28fca2ccfd38b8f = $f18f6e3856e45eb6$var$updateLocation('goBack');
var $f18f6e3856e45eb6$export$994d0e87e52ba8e3 = $f18f6e3856e45eb6$var$updateLocation('goForward');
var $f18f6e3856e45eb6$export$95755023e698c378 = {
    push: $f18f6e3856e45eb6$export$4cbf152802aa238,
    replace: $f18f6e3856e45eb6$export$77ad94ebf1c2b9ed,
    go: $f18f6e3856e45eb6$export$93bb224d05b3906d,
    goBack: $f18f6e3856e45eb6$export$28fca2ccfd38b8f,
    goForward: $f18f6e3856e45eb6$export$994d0e87e52ba8e3
};
module.exports["LOCATION_CHANGE"] = $f18f6e3856e45eb6$export$be84bd1ba815d4c2;
module.exports["onLocationChanged"] = $f18f6e3856e45eb6$export$924382de27029fe1;
module.exports["CALL_HISTORY_METHOD"] = $f18f6e3856e45eb6$export$d035cdafa5d37a89;
module.exports["push"] = $f18f6e3856e45eb6$export$4cbf152802aa238;
module.exports["replace"] = $f18f6e3856e45eb6$export$77ad94ebf1c2b9ed;

});

parcelRegister("dBmJE", function(module, exports) {

var $42omo = parcelRequire("42omo");


var $4xcIM = parcelRequire("4xcIM");


var $kFqI2 = parcelRequire("kFqI2");


var $QU6QS = parcelRequire("QU6QS");


var $h7Ze1 = parcelRequire("h7Ze1");


var $kJOOQ = parcelRequire("kJOOQ");




function $939a539a2666a339$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $939a539a2666a339$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $939a539a2666a339$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $939a539a2666a339$var$_typeof(obj);
}
var $939a539a2666a339$var$createSelectors = function createSelectors(structure) {
    var getIn = structure.getIn, toJS = structure.toJS;
    var isRouter = function isRouter(value) {
        return value != null && $939a539a2666a339$var$_typeof(value) === 'object' && getIn(value, [
            'location'
        ]) && getIn(value, [
            'action'
        ]);
    };
    var getRouter = function getRouter(state) {
        var router = toJS(getIn(state, [
            'router'
        ]));
        if (!isRouter(router)) throw 'Could not find router reducer in state tree, it must be mounted under "router"';
        return router;
    };
    var getLocation = function getLocation(state) {
        return toJS(getIn(getRouter(state), [
            'location'
        ]));
    };
    var getAction = function getAction(state) {
        return toJS(getIn(getRouter(state), [
            'action'
        ]));
    };
    var getSearch = function getSearch(state) {
        return toJS(getIn(getRouter(state), [
            'location',
            'search'
        ]));
    };
    var getHash = function getHash(state) {
        return toJS(getIn(getRouter(state), [
            'location',
            'hash'
        ]));
    }; // It only makes sense to recalculate the `matchPath` whenever the pathname
    // of the location changes. That's why `createMatchSelector` memoizes
    // the latest result based on the location's pathname.
    var createMatchSelector = function createMatchSelector(path) {
        var lastPathname = null;
        var lastMatch = null;
        return function(state) {
            var _ref = getLocation(state) || {}, pathname = _ref.pathname;
            if (pathname === lastPathname) return lastMatch;
            lastPathname = pathname;
            var match = (0, $QU6QS.matchPath)(pathname, path);
            if (!match || !lastMatch || match.url !== lastMatch.url // When URL matched for nested routes, URL is the same but isExact is not.
             || match.isExact !== lastMatch.isExact) lastMatch = match;
            return lastMatch;
        };
    };
    return {
        getLocation: getLocation,
        getAction: getAction,
        getRouter: getRouter,
        getSearch: getSearch,
        getHash: getHash,
        createMatchSelector: createMatchSelector
    };
};
var $939a539a2666a339$export$2e2bcd8739ae039 = $939a539a2666a339$var$createSelectors;


function $f3f655976ac56086$var$_typeof(obj) {
    "@babel/helpers - typeof";
    if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") $f3f655976ac56086$var$_typeof = function _typeof(obj) {
        return typeof obj;
    };
    else $f3f655976ac56086$var$_typeof = function _typeof(obj) {
        return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
    return $f3f655976ac56086$var$_typeof(obj);
}
function $f3f655976ac56086$var$_extends() {
    $f3f655976ac56086$var$_extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f3f655976ac56086$var$_extends.apply(this, arguments);
}
function $f3f655976ac56086$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $f3f655976ac56086$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $f3f655976ac56086$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $f3f655976ac56086$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $f3f655976ac56086$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}
function $f3f655976ac56086$var$_createSuper(Derived) {
    return function() {
        var Super = $f3f655976ac56086$var$_getPrototypeOf(Derived), result;
        if ($f3f655976ac56086$var$_isNativeReflectConstruct()) {
            var NewTarget = $f3f655976ac56086$var$_getPrototypeOf(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return $f3f655976ac56086$var$_possibleConstructorReturn(this, result);
    };
}
function $f3f655976ac56086$var$_possibleConstructorReturn(self, call) {
    if (call && ($f3f655976ac56086$var$_typeof(call) === "object" || typeof call === "function")) return call;
    return $f3f655976ac56086$var$_assertThisInitialized(self);
}
function $f3f655976ac56086$var$_assertThisInitialized(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}
function $f3f655976ac56086$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Date.prototype.toString.call(Reflect.construct(Date, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $f3f655976ac56086$var$_getPrototypeOf(o) {
    $f3f655976ac56086$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $f3f655976ac56086$var$_getPrototypeOf(o);
}
function $f3f655976ac56086$var$_inherits(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) $f3f655976ac56086$var$_setPrototypeOf(subClass, superClass);
}
function $f3f655976ac56086$var$_setPrototypeOf(o, p) {
    $f3f655976ac56086$var$_setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $f3f655976ac56086$var$_setPrototypeOf(o, p);
}
var $f3f655976ac56086$var$createConnectedRouter = function createConnectedRouter(structure) {
    var _createSelectors = (0, $939a539a2666a339$export$2e2bcd8739ae039)(structure), getLocation = _createSelectors.getLocation;
    /*
   * ConnectedRouter listens to a history object passed from props.
   * When history is changed, it dispatches action to redux store.
   * Then, store will pass props to component to render.
   * This creates uni-directional flow from history->store->router->components.
   */ var ConnectedRouter = /*#__PURE__*/ function(_PureComponent) {
        $f3f655976ac56086$var$_inherits(ConnectedRouter, _PureComponent);
        var _super = $f3f655976ac56086$var$_createSuper(ConnectedRouter);
        function ConnectedRouter(props) {
            var _this;
            $f3f655976ac56086$var$_classCallCheck(this, ConnectedRouter);
            _this = _super.call(this, props);
            var store = props.store, history = props.history, onLocationChanged = props.onLocationChanged, stateCompareFunction = props.stateCompareFunction;
            _this.inTimeTravelling = false; // Subscribe to store changes to check if we are in time travelling
            _this.unsubscribe = store.subscribe(function() {
                // Allow time travel debugging compatibility to be turned off
                // as the detection for this (below) is error prone in apps where the
                // store may be unmounted, a navigation occurs, and then the store is re-mounted
                // during the app's lifetime. Detection could be much improved if Redux DevTools
                // simply set a global variable like `REDUX_DEVTOOLS_IS_TIME_TRAVELLING=true`.
                var isTimeTravelDebuggingAllowed = !props.noTimeTravelDebugging; // Extract store's location
                var _getLocation = getLocation(store.getState()), pathnameInStore = _getLocation.pathname, searchInStore = _getLocation.search, hashInStore = _getLocation.hash, stateInStore = _getLocation.state; // Extract history's location
                var _history$location = history.location, pathnameInHistory = _history$location.pathname, searchInHistory = _history$location.search, hashInHistory = _history$location.hash, stateInHistory = _history$location.state; // If we do time travelling, the location in store is changed but location in history is not changed
                if (isTimeTravelDebuggingAllowed && props.history.action === 'PUSH' && (pathnameInHistory !== pathnameInStore || searchInHistory !== searchInStore || hashInHistory !== hashInStore || !(0, (/*@__PURE__*/$parcel$interopDefault($h7Ze1)))(stateInStore, stateInHistory, stateCompareFunction))) {
                    _this.inTimeTravelling = true; // Update history's location to match store's location
                    history.push({
                        pathname: pathnameInStore,
                        search: searchInStore,
                        hash: hashInStore,
                        state: stateInStore
                    });
                }
            });
            var handleLocationChange = function handleLocationChange(location, action) {
                var isFirstRendering = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
                // Dispatch onLocationChanged except when we're in time travelling
                if (!_this.inTimeTravelling) onLocationChanged(location, action, isFirstRendering);
                else _this.inTimeTravelling = false;
            }; // Listen to history changes
            _this.unlisten = history.listen(handleLocationChange);
            if (!props.noInitialPop) // Dispatch a location change action for the initial location.
            // This makes it backward-compatible with react-router-redux.
            // But, we add `isFirstRendering` to `true` to prevent double-rendering.
            handleLocationChange(history.location, history.action, true);
            return _this;
        }
        $f3f655976ac56086$var$_createClass(ConnectedRouter, [
            {
                key: "componentWillUnmount",
                value: function componentWillUnmount() {
                    this.unlisten();
                    this.unsubscribe();
                }
            },
            {
                key: "render",
                value: function render() {
                    var _this$props = this.props, omitRouter = _this$props.omitRouter, history = _this$props.history, children = _this$props.children; // The `omitRouter` option is available for applications that must
                    // have a Router instance higher in the component tree but still desire
                    // to use connected-react-router for its Redux integration.
                    if (omitRouter) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($42omo))).Fragment, null, children);
                    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement((0, $QU6QS.Router), {
                        history: history
                    }, children);
                }
            }
        ]);
        return ConnectedRouter;
    }((0, $42omo.PureComponent));
    ConnectedRouter.propTypes = {
        store: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).shape({
            getState: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
            subscribe: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired
        }).isRequired,
        history: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).shape({
            action: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string.isRequired,
            listen: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
            location: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object.isRequired,
            push: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired
        }).isRequired,
        basename: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).string,
        children: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).oneOfType([
            (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
            (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).node
        ]),
        onLocationChanged: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func.isRequired,
        noInitialPop: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
        noTimeTravelDebugging: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool,
        stateCompareFunction: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).func,
        omitRouter: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).bool
    };
    var mapDispatchToProps = function mapDispatchToProps(dispatch) {
        return {
            onLocationChanged: function onLocationChanged(location, action, isFirstRendering) {
                return dispatch((0, $kJOOQ.onLocationChanged)(location, action, isFirstRendering));
            }
        };
    };
    var ConnectedRouterWithContext = function ConnectedRouterWithContext(props) {
        var Context = props.context || (0, $kFqI2.ReactReduxContext);
        if (Context == null) throw 'Please upgrade to react-redux v6';
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(Context.Consumer, null, function(_ref) {
            var store = _ref.store;
            return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(ConnectedRouter, $f3f655976ac56086$var$_extends({
                store: store
            }, props));
        });
    };
    ConnectedRouterWithContext.propTypes = {
        context: (0, (/*@__PURE__*/$parcel$interopDefault($4xcIM))).object
    };
    return (0, $kFqI2.connect)(null, mapDispatchToProps)(ConnectedRouterWithContext);
};
var $f3f655976ac56086$export$2e2bcd8739ae039 = $f3f655976ac56086$var$createConnectedRouter;





function $c90219660dd7d6b0$var$_slicedToArray(arr, i) {
    return $c90219660dd7d6b0$var$_arrayWithHoles(arr) || $c90219660dd7d6b0$var$_iterableToArrayLimit(arr, i) || $c90219660dd7d6b0$var$_unsupportedIterableToArray(arr, i) || $c90219660dd7d6b0$var$_nonIterableRest();
}
function $c90219660dd7d6b0$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $c90219660dd7d6b0$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $c90219660dd7d6b0$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $c90219660dd7d6b0$var$_arrayLikeToArray(o, minLen);
}
function $c90219660dd7d6b0$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $c90219660dd7d6b0$var$_iterableToArrayLimit(arr, i) {
    if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _e = undefined;
    try {
        for(var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function $c90219660dd7d6b0$var$_arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function $c90219660dd7d6b0$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $c90219660dd7d6b0$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $c90219660dd7d6b0$var$ownKeys(Object(source), true).forEach(function(key) {
            $c90219660dd7d6b0$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $c90219660dd7d6b0$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $c90219660dd7d6b0$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
/**
 * Adds query to location.
 * Utilises the search prop of location to construct query.
 */ var $c90219660dd7d6b0$var$injectQuery = function injectQuery(location) {
    if (location && location.query) // Don't inject query if it already exists in history
    return location;
    var searchQuery = location && location.search;
    if (typeof searchQuery !== 'string' || searchQuery.length === 0) return $c90219660dd7d6b0$var$_objectSpread({}, location, {
        query: {}
    });
     // Ignore the `?` part of the search string e.g. ?username=codejockie
    var search = searchQuery.substring(1); // Split the query string on `&` e.g. ?username=codejockie&name=Kennedy
    var queries = search.split('&'); // Contruct query
    var query = queries.reduce(function(acc, currentQuery) {
        // Split on `=`, to get key and value
        var _currentQuery$split = currentQuery.split('='), _currentQuery$split2 = $c90219660dd7d6b0$var$_slicedToArray(_currentQuery$split, 2), queryKey = _currentQuery$split2[0], queryValue = _currentQuery$split2[1];
        return $c90219660dd7d6b0$var$_objectSpread({}, acc, $c90219660dd7d6b0$var$_defineProperty({}, queryKey, queryValue));
    }, {});
    return $c90219660dd7d6b0$var$_objectSpread({}, location, {
        query: query
    });
};
var $c90219660dd7d6b0$var$createConnectRouter = function createConnectRouter(structure) {
    var fromJS = structure.fromJS, merge = structure.merge;
    var createRouterReducer = function createRouterReducer(history) {
        var initialRouterState = fromJS({
            location: $c90219660dd7d6b0$var$injectQuery(history.location),
            action: history.action
        });
        /*
    * This reducer will update the state with the most recent location history
    * has transitioned to.
    */ return function() {
            var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialRouterState;
            var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, type = _ref.type, payload = _ref.payload;
            if (type === (0, $kJOOQ.LOCATION_CHANGE)) {
                var location = payload.location, action = payload.action, isFirstRendering = payload.isFirstRendering; // Don't update the state ref for the first rendering
                // to prevent the double-rendering issue on initilization
                return isFirstRendering ? state : merge(state, {
                    location: fromJS($c90219660dd7d6b0$var$injectQuery(location)),
                    action: action
                });
            }
            return state;
        };
    };
    return createRouterReducer;
};
var $c90219660dd7d6b0$export$2e2bcd8739ae039 = $c90219660dd7d6b0$var$createConnectRouter;



/* Code from github.com/erikras/redux-form by Erik Rasmussen */ var $f316cad0c3083d2a$var$getIn = function getIn(state, path) {
    if (!state) return state;
    var length = path.length;
    if (!length) return undefined;
    var result = state;
    for(var i = 0; i < length && !!result; ++i)result = result[path[i]];
    return result;
};
var $f316cad0c3083d2a$export$2e2bcd8739ae039 = $f316cad0c3083d2a$var$getIn;


function $1c6a996509ccc70c$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $1c6a996509ccc70c$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        if (i % 2) $1c6a996509ccc70c$var$ownKeys(Object(source), true).forEach(function(key) {
            $1c6a996509ccc70c$var$_defineProperty(target, key, source[key]);
        });
        else if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
        else $1c6a996509ccc70c$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $1c6a996509ccc70c$var$_defineProperty(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
var $1c6a996509ccc70c$var$structure = {
    fromJS: function fromJS(value) {
        return value;
    },
    getIn: (0, $f316cad0c3083d2a$export$2e2bcd8739ae039),
    merge: function merge(state, payload) {
        return $1c6a996509ccc70c$var$_objectSpread({}, state, {}, payload);
    },
    toJS: function toJS(value) {
        return value;
    }
};
var $1c6a996509ccc70c$export$2e2bcd8739ae039 = $1c6a996509ccc70c$var$structure;






var $8aej1 = parcelRequire("8aej1");

var $9e705dd855a29e46$export$28f92b8268ba8447 = /*#__PURE__*/ (0, $f3f655976ac56086$export$2e2bcd8739ae039)((0, $1c6a996509ccc70c$export$2e2bcd8739ae039));
var $9e705dd855a29e46$export$2c021ec3f68e26bf = /*#__PURE__*/ (0, $c90219660dd7d6b0$export$2e2bcd8739ae039)((0, $1c6a996509ccc70c$export$2e2bcd8739ae039));
var $9e705dd855a29e46$var$_createSelectors = /*#__PURE__*/ (0, $939a539a2666a339$export$2e2bcd8739ae039)((0, $1c6a996509ccc70c$export$2e2bcd8739ae039)), $9e705dd855a29e46$export$e7fd20fad3cf4b5f = $9e705dd855a29e46$var$_createSelectors.getLocation, $9e705dd855a29e46$export$6ca3170acb89054 = $9e705dd855a29e46$var$_createSelectors.getAction, $9e705dd855a29e46$export$adaba664e531641c = $9e705dd855a29e46$var$_createSelectors.getHash, $9e705dd855a29e46$export$3b1eb3bad78dcdd4 = $9e705dd855a29e46$var$_createSelectors.getRouter, $9e705dd855a29e46$export$786f9a4bc80cc6b0 = $9e705dd855a29e46$var$_createSelectors.getSearch, $9e705dd855a29e46$export$a7b4d762fce9f62a = $9e705dd855a29e46$var$_createSelectors.createMatchSelector;
module.exports["ConnectedRouter"] = $9e705dd855a29e46$export$28f92b8268ba8447;
module.exports["connectRouter"] = $9e705dd855a29e46$export$2c021ec3f68e26bf;

});

parcelRegister("byqwv", function(module, exports) {

var $hXuPC = parcelRequire("hXuPC");


var $42omo = parcelRequire("42omo");


var $1cfRh = parcelRequire("1cfRh");

var $869771a50d763bfe$var$DisplayName;
(function(DisplayName) {
    DisplayName["formatDate"] = "FormattedDate";
    DisplayName["formatTime"] = "FormattedTime";
    DisplayName["formatNumber"] = "FormattedNumber";
    DisplayName["formatList"] = "FormattedList";
    // Note that this DisplayName is the locale display name, not to be confused with
    // the name of the enum, which is for React component display name in dev tools.
    DisplayName["formatDisplayName"] = "FormattedDisplayName";
})($869771a50d763bfe$var$DisplayName || ($869771a50d763bfe$var$DisplayName = {}));
var $869771a50d763bfe$var$DisplayNameParts;
(function(DisplayNameParts) {
    DisplayNameParts["formatDate"] = "FormattedDateParts";
    DisplayNameParts["formatTime"] = "FormattedTimeParts";
    DisplayNameParts["formatNumber"] = "FormattedNumberParts";
    DisplayNameParts["formatList"] = "FormattedListParts";
})($869771a50d763bfe$var$DisplayNameParts || ($869771a50d763bfe$var$DisplayNameParts = {}));
var $869771a50d763bfe$export$54d4989ed3eea1ea = function(props) {
    var intl = (0, $1cfRh.default)();
    var value = props.value, children = props.children, formatProps = (0, $hXuPC.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatNumberToParts(value, formatProps));
};
$869771a50d763bfe$export$54d4989ed3eea1ea.displayName = 'FormattedNumberParts';
var $869771a50d763bfe$export$5ac259c7da6d2188 = function(props) {
    var intl = (0, $1cfRh.default)();
    var value = props.value, children = props.children, formatProps = (0, $hXuPC.__rest)(props, [
        "value",
        "children"
    ]);
    return children(intl.formatListToParts(value, formatProps));
};
$869771a50d763bfe$export$54d4989ed3eea1ea.displayName = 'FormattedNumberParts';
function $869771a50d763bfe$export$7448277f6036d2ab(name) {
    var ComponentParts = function(props) {
        var intl = (0, $1cfRh.default)();
        var value = props.value, children = props.children, formatProps = (0, $hXuPC.__rest)(props, [
            "value",
            "children"
        ]);
        var date = typeof value === 'string' ? new Date(value || 0) : value;
        var formattedParts = name === 'formatDate' ? intl.formatDateToParts(date, formatProps) : intl.formatTimeToParts(date, formatProps);
        return children(formattedParts);
    };
    ComponentParts.displayName = $869771a50d763bfe$var$DisplayNameParts[name];
    return ComponentParts;
}
function $869771a50d763bfe$export$b37e14176d001dec(name) {
    var Component = function(props) {
        var intl = (0, $1cfRh.default)();
        var value = props.value, children = props.children, formatProps = (0, $hXuPC.__rest)(props, [
            "value",
            "children"
        ]);
        // TODO: fix TS type definition for localeMatcher upstream
        var formattedValue = intl[name](value, formatProps);
        if (typeof children === 'function') return children(formattedValue);
        var Text = intl.textComponent || $42omo.Fragment;
        return $42omo.createElement(Text, null, formattedValue);
    };
    Component.displayName = $869771a50d763bfe$var$DisplayName[name];
    return Component;
}
module.exports["FormattedNumberParts"] = $869771a50d763bfe$export$54d4989ed3eea1ea;
module.exports["FormattedListParts"] = $869771a50d763bfe$export$5ac259c7da6d2188;
module.exports["createFormattedDateTimePartsComponent"] = $869771a50d763bfe$export$7448277f6036d2ab;
module.exports["createFormattedComponent"] = $869771a50d763bfe$export$b37e14176d001dec;

});

parcelRegister("2mpAJ", function(module, exports) {

var $hXuPC = parcelRequire("hXuPC");


var $42omo = parcelRequire("42omo");


var $1cfRh = parcelRequire("1cfRh");

var $1b817cc196fe8492$var$FormattedDateTimeRange = function(props) {
    var intl = (0, $1cfRh.default)();
    var from = props.from, to = props.to, children = props.children, formatProps = (0, $hXuPC.__rest)(props, [
        "from",
        "to",
        "children"
    ]);
    var formattedValue = intl.formatDateTimeRange(from, to, formatProps);
    if (typeof children === 'function') return children(formattedValue);
    var Text = intl.textComponent || $42omo.Fragment;
    return $42omo.createElement(Text, null, formattedValue);
};
$1b817cc196fe8492$var$FormattedDateTimeRange.displayName = 'FormattedDateTimeRange';
var $1b817cc196fe8492$export$2e2bcd8739ae039 = $1b817cc196fe8492$var$FormattedDateTimeRange;
module.exports["default"] = $1b817cc196fe8492$export$2e2bcd8739ae039;

});

parcelRegister("hWPZ1", function(module, exports) {
/*
 * Copyright 2015, Yahoo Inc.
 * Copyrights licensed under the New BSD License.
 * See the accompanying LICENSE file for terms.
 */ 
var $42omo = parcelRequire("42omo");


var $1cfRh = parcelRequire("1cfRh");

var $d1102d387e97a6a3$var$FormattedPlural = function(props) {
    var _a = (0, $1cfRh.default)(), formatPlural = _a.formatPlural, Text = _a.textComponent;
    var value = props.value, other = props.other, children = props.children;
    var pluralCategory = formatPlural(value, props);
    var formattedPlural = props[pluralCategory] || other;
    if (typeof children === 'function') return children(formattedPlural);
    if (Text) return $42omo.createElement(Text, null, formattedPlural);
    // Work around @types/react where React.FC cannot return string
    return formattedPlural;
};
$d1102d387e97a6a3$var$FormattedPlural.displayName = 'FormattedPlural';
var $d1102d387e97a6a3$export$2e2bcd8739ae039 = $d1102d387e97a6a3$var$FormattedPlural;
module.exports["default"] = $d1102d387e97a6a3$export$2e2bcd8739ae039;

});

parcelRegister("iNgUL", function(module, exports) {
$parcel$export(module.exports, "IntlErrorCode", () => $dae9ec7a82c9d9d9$export$557d6acb76e8a244);

var $hXuPC = parcelRequire("hXuPC");

var $dae9ec7a82c9d9d9$export$557d6acb76e8a244;
(function(IntlErrorCode) {
    IntlErrorCode["FORMAT_ERROR"] = "FORMAT_ERROR";
    IntlErrorCode["UNSUPPORTED_FORMATTER"] = "UNSUPPORTED_FORMATTER";
    IntlErrorCode["INVALID_CONFIG"] = "INVALID_CONFIG";
    IntlErrorCode["MISSING_DATA"] = "MISSING_DATA";
    IntlErrorCode["MISSING_TRANSLATION"] = "MISSING_TRANSLATION";
})($dae9ec7a82c9d9d9$export$557d6acb76e8a244 || ($dae9ec7a82c9d9d9$export$557d6acb76e8a244 = {}));
var $dae9ec7a82c9d9d9$export$c016d36112f6ddf8 = /** @class */ function(_super) {
    (0, $hXuPC.__extends)(IntlError, _super);
    function IntlError(code, message, exception) {
        var _this = this;
        var err = exception ? exception instanceof Error ? exception : new Error(String(exception)) : undefined;
        _this = _super.call(this, "[@formatjs/intl Error ".concat(code, "] ").concat(message, "\n").concat(err ? "\n".concat(err.message, "\n").concat(err.stack) : '')) || this;
        _this.code = code;
        // @ts-ignore just so we don't need to declare dep on @types/node
        if (typeof Error.captureStackTrace === 'function') // @ts-ignore just so we don't need to declare dep on @types/node
        Error.captureStackTrace(_this, IntlError);
        return _this;
    }
    return IntlError;
}(Error);
var $dae9ec7a82c9d9d9$export$549f97e137a05c90 = /** @class */ function(_super) {
    (0, $hXuPC.__extends)(UnsupportedFormatterError, _super);
    function UnsupportedFormatterError(message, exception) {
        return _super.call(this, $dae9ec7a82c9d9d9$export$557d6acb76e8a244.UNSUPPORTED_FORMATTER, message, exception) || this;
    }
    return UnsupportedFormatterError;
}($dae9ec7a82c9d9d9$export$c016d36112f6ddf8);
var $dae9ec7a82c9d9d9$export$3ca04dd7fb305893 = /** @class */ function(_super) {
    (0, $hXuPC.__extends)(InvalidConfigError, _super);
    function InvalidConfigError(message, exception) {
        return _super.call(this, $dae9ec7a82c9d9d9$export$557d6acb76e8a244.INVALID_CONFIG, message, exception) || this;
    }
    return InvalidConfigError;
}($dae9ec7a82c9d9d9$export$c016d36112f6ddf8);
var $dae9ec7a82c9d9d9$export$c1eaf877d81384b6 = /** @class */ function(_super) {
    (0, $hXuPC.__extends)(MissingDataError, _super);
    function MissingDataError(message, exception) {
        return _super.call(this, $dae9ec7a82c9d9d9$export$557d6acb76e8a244.MISSING_DATA, message, exception) || this;
    }
    return MissingDataError;
}($dae9ec7a82c9d9d9$export$c016d36112f6ddf8);
var $dae9ec7a82c9d9d9$export$e3b7eee1dbc44895 = /** @class */ function(_super) {
    (0, $hXuPC.__extends)(IntlFormatError, _super);
    function IntlFormatError(message, locale, exception) {
        var _this = _super.call(this, $dae9ec7a82c9d9d9$export$557d6acb76e8a244.FORMAT_ERROR, "".concat(message, "\nLocale: ").concat(locale, "\n"), exception) || this;
        _this.locale = locale;
        return _this;
    }
    return IntlFormatError;
}($dae9ec7a82c9d9d9$export$c016d36112f6ddf8);
var $dae9ec7a82c9d9d9$export$74a601a3d3f31621 = /** @class */ function(_super) {
    (0, $hXuPC.__extends)(MessageFormatError, _super);
    function MessageFormatError(message, locale, descriptor, exception) {
        var _this = _super.call(this, "".concat(message, "\nMessageID: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.id, "\nDefault Message: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.defaultMessage, "\nDescription: ").concat(descriptor === null || descriptor === void 0 ? void 0 : descriptor.description, "\n"), locale, exception) || this;
        _this.descriptor = descriptor;
        _this.locale = locale;
        return _this;
    }
    return MessageFormatError;
}($dae9ec7a82c9d9d9$export$e3b7eee1dbc44895);
var $dae9ec7a82c9d9d9$export$2ddcb436d0aa3688 = /** @class */ function(_super) {
    (0, $hXuPC.__extends)(MissingTranslationError, _super);
    function MissingTranslationError(descriptor, locale) {
        var _this = _super.call(this, $dae9ec7a82c9d9d9$export$557d6acb76e8a244.MISSING_TRANSLATION, "Missing message: \"".concat(descriptor.id, "\" for locale \"").concat(locale, "\", using ").concat(descriptor.defaultMessage ? "default message (".concat(typeof descriptor.defaultMessage === 'string' ? descriptor.defaultMessage : descriptor.defaultMessage.map(function(e) {
            var _a;
            return (_a = e.value) !== null && _a !== void 0 ? _a : JSON.stringify(e);
        }).join(), ")") : 'id', " as fallback.")) || this;
        _this.descriptor = descriptor;
        return _this;
    }
    return MissingTranslationError;
}($dae9ec7a82c9d9d9$export$c016d36112f6ddf8);
module.exports["IntlError"] = $dae9ec7a82c9d9d9$export$c016d36112f6ddf8;
module.exports["UnsupportedFormatterError"] = $dae9ec7a82c9d9d9$export$549f97e137a05c90;
module.exports["InvalidConfigError"] = $dae9ec7a82c9d9d9$export$3ca04dd7fb305893;
module.exports["MissingDataError"] = $dae9ec7a82c9d9d9$export$c1eaf877d81384b6;
module.exports["IntlFormatError"] = $dae9ec7a82c9d9d9$export$e3b7eee1dbc44895;
module.exports["MessageFormatError"] = $dae9ec7a82c9d9d9$export$74a601a3d3f31621;
module.exports["MissingTranslationError"] = $dae9ec7a82c9d9d9$export$2ddcb436d0aa3688;

});

parcelRegister("9m5ne", function(module, exports) {
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $hXuPC = parcelRequire("hXuPC");


var $feah2 = parcelRequire("feah2");


var $euVWZ = parcelRequire("euVWZ");


var $38rme = parcelRequire("38rme");

// -- MessageFormat --------------------------------------------------------
function $6cfa5641beaf68c8$var$mergeConfig(c1, c2) {
    if (!c2) return c1;
    return (0, $hXuPC.__assign)((0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, c1 || {}), c2 || {}), Object.keys(c1).reduce(function(all, k) {
        all[k] = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, c1[k]), c2[k] || {});
        return all;
    }, {}));
}
function $6cfa5641beaf68c8$var$mergeConfigs(defaultConfig, configs) {
    if (!configs) return defaultConfig;
    return Object.keys(defaultConfig).reduce(function(all, k) {
        all[k] = $6cfa5641beaf68c8$var$mergeConfig(defaultConfig[k], configs[k]);
        return all;
    }, (0, $hXuPC.__assign)({}, defaultConfig));
}
function $6cfa5641beaf68c8$var$createFastMemoizeCache(store) {
    return {
        create: function() {
            return {
                get: function(key) {
                    return store[key];
                },
                set: function(key, value) {
                    store[key] = value;
                }
            };
        }
    };
}
function $6cfa5641beaf68c8$var$createDefaultFormatters(cache) {
    if (cache === void 0) cache = {
        number: {},
        dateTime: {},
        pluralRules: {}
    };
    return {
        getNumberFormat: (0, $feah2.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.NumberFormat).bind.apply(_a, (0, $hXuPC.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $6cfa5641beaf68c8$var$createFastMemoizeCache(cache.number),
            strategy: (0, $feah2.strategies).variadic
        }),
        getDateTimeFormat: (0, $feah2.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.DateTimeFormat).bind.apply(_a, (0, $hXuPC.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $6cfa5641beaf68c8$var$createFastMemoizeCache(cache.dateTime),
            strategy: (0, $feah2.strategies).variadic
        }),
        getPluralRules: (0, $feah2.memoize)(function() {
            var _a;
            var args = [];
            for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
            return new ((_a = Intl.PluralRules).bind.apply(_a, (0, $hXuPC.__spreadArray)([
                void 0
            ], args, false)))();
        }, {
            cache: $6cfa5641beaf68c8$var$createFastMemoizeCache(cache.pluralRules),
            strategy: (0, $feah2.strategies).variadic
        })
    };
}
var $6cfa5641beaf68c8$export$d342343268debc40 = /** @class */ function() {
    function IntlMessageFormat(message, locales, overrideFormats, opts) {
        if (locales === void 0) locales = IntlMessageFormat.defaultLocale;
        var _this = this;
        this.formatterCache = {
            number: {},
            dateTime: {},
            pluralRules: {}
        };
        this.format = function(values) {
            var parts = _this.formatToParts(values);
            // Hot path for straight simple msg translations
            if (parts.length === 1) return parts[0].value;
            var result = parts.reduce(function(all, part) {
                if (!all.length || part.type !== (0, $38rme.PART_TYPE).literal || typeof all[all.length - 1] !== 'string') all.push(part.value);
                else all[all.length - 1] += part.value;
                return all;
            }, []);
            if (result.length <= 1) return result[0] || '';
            return result;
        };
        this.formatToParts = function(values) {
            return (0, $38rme.formatToParts)(_this.ast, _this.locales, _this.formatters, _this.formats, values, undefined, _this.message);
        };
        this.resolvedOptions = function() {
            var _a;
            return {
                locale: ((_a = _this.resolvedLocale) === null || _a === void 0 ? void 0 : _a.toString()) || Intl.NumberFormat.supportedLocalesOf(_this.locales)[0]
            };
        };
        this.getAst = function() {
            return _this.ast;
        };
        // Defined first because it's used to build the format pattern.
        this.locales = locales;
        this.resolvedLocale = IntlMessageFormat.resolveLocale(locales);
        if (typeof message === 'string') {
            this.message = message;
            if (!IntlMessageFormat.__parse) throw new TypeError('IntlMessageFormat.__parse must be set to process `message` of type `string`');
            var _a = opts || {}, formatters = _a.formatters, parseOpts = (0, $hXuPC.__rest)(_a, [
                "formatters"
            ]);
            // Parse string messages into an AST.
            this.ast = IntlMessageFormat.__parse(message, (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, parseOpts), {
                locale: this.resolvedLocale
            }));
        } else this.ast = message;
        if (!Array.isArray(this.ast)) throw new TypeError('A message must be provided as a String or AST.');
        // Creates a new object with the specified `formats` merged with the default
        // formats.
        this.formats = $6cfa5641beaf68c8$var$mergeConfigs(IntlMessageFormat.formats, overrideFormats);
        this.formatters = opts && opts.formatters || $6cfa5641beaf68c8$var$createDefaultFormatters(this.formatterCache);
    }
    Object.defineProperty(IntlMessageFormat, "defaultLocale", {
        get: function() {
            if (!IntlMessageFormat.memoizedDefaultLocale) IntlMessageFormat.memoizedDefaultLocale = new Intl.NumberFormat().resolvedOptions().locale;
            return IntlMessageFormat.memoizedDefaultLocale;
        },
        enumerable: false,
        configurable: true
    });
    IntlMessageFormat.memoizedDefaultLocale = null;
    IntlMessageFormat.resolveLocale = function(locales) {
        if (typeof Intl.Locale === 'undefined') return;
        var supportedLocales = Intl.NumberFormat.supportedLocalesOf(locales);
        if (supportedLocales.length > 0) return new Intl.Locale(supportedLocales[0]);
        return new Intl.Locale(typeof locales === 'string' ? locales : locales[0]);
    };
    IntlMessageFormat.__parse = (0, $euVWZ.parse);
    // Default format options used as the prototype of the `formats` provided to the
    // constructor. These are used when constructing the internal Intl.NumberFormat
    // and Intl.DateTimeFormat instances.
    IntlMessageFormat.formats = {
        number: {
            integer: {
                maximumFractionDigits: 0
            },
            currency: {
                style: 'currency'
            },
            percent: {
                style: 'percent'
            }
        },
        date: {
            short: {
                month: 'numeric',
                day: 'numeric',
                year: '2-digit'
            },
            medium: {
                month: 'short',
                day: 'numeric',
                year: 'numeric'
            },
            long: {
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            },
            full: {
                weekday: 'long',
                month: 'long',
                day: 'numeric',
                year: 'numeric'
            }
        },
        time: {
            short: {
                hour: 'numeric',
                minute: 'numeric'
            },
            medium: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric'
            },
            long: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            },
            full: {
                hour: 'numeric',
                minute: 'numeric',
                second: 'numeric',
                timeZoneName: 'short'
            }
        }
    };
    return IntlMessageFormat;
}();
module.exports["IntlMessageFormat"] = $6cfa5641beaf68c8$export$d342343268debc40;

});

parcelRegister("1q4lC", function(module, exports) {
$parcel$export(module.exports, "ErrorCode", () => $108b97800ea04239$export$d4e71bc0b80dc0fb);

var $hXuPC = parcelRequire("hXuPC");

var $108b97800ea04239$export$d4e71bc0b80dc0fb;
(function(ErrorCode) {
    // When we have a placeholder but no value to format
    ErrorCode["MISSING_VALUE"] = "MISSING_VALUE";
    // When value supplied is invalid
    ErrorCode["INVALID_VALUE"] = "INVALID_VALUE";
    // When we need specific Intl API but it's not available
    ErrorCode["MISSING_INTL_API"] = "MISSING_INTL_API";
})($108b97800ea04239$export$d4e71bc0b80dc0fb || ($108b97800ea04239$export$d4e71bc0b80dc0fb = {}));
var $108b97800ea04239$export$7369836851cc1329 = /** @class */ function(_super) {
    (0, $hXuPC.__extends)(FormatError, _super);
    function FormatError(msg, code, originalMessage) {
        var _this = _super.call(this, msg) || this;
        _this.code = code;
        _this.originalMessage = originalMessage;
        return _this;
    }
    FormatError.prototype.toString = function() {
        return "[formatjs Error: ".concat(this.code, "] ").concat(this.message);
    };
    return FormatError;
}(Error);
var $108b97800ea04239$export$565c3afc07dfa382 = /** @class */ function(_super) {
    (0, $hXuPC.__extends)(InvalidValueError, _super);
    function InvalidValueError(variableId, value, options, originalMessage) {
        return _super.call(this, "Invalid values for \"".concat(variableId, "\": \"").concat(value, "\". Options are \"").concat(Object.keys(options).join('", "'), "\""), $108b97800ea04239$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueError;
}($108b97800ea04239$export$7369836851cc1329);
var $108b97800ea04239$export$cbc0db47c750f7c9 = /** @class */ function(_super) {
    (0, $hXuPC.__extends)(InvalidValueTypeError, _super);
    function InvalidValueTypeError(value, type, originalMessage) {
        return _super.call(this, "Value for \"".concat(value, "\" must be of type ").concat(type), $108b97800ea04239$export$d4e71bc0b80dc0fb.INVALID_VALUE, originalMessage) || this;
    }
    return InvalidValueTypeError;
}($108b97800ea04239$export$7369836851cc1329);
var $108b97800ea04239$export$8bfc137e4d23fdf0 = /** @class */ function(_super) {
    (0, $hXuPC.__extends)(MissingValueError, _super);
    function MissingValueError(variableId, originalMessage) {
        return _super.call(this, "The intl string context variable \"".concat(variableId, "\" was not provided to the string \"").concat(originalMessage, "\""), $108b97800ea04239$export$d4e71bc0b80dc0fb.MISSING_VALUE, originalMessage) || this;
    }
    return MissingValueError;
}($108b97800ea04239$export$7369836851cc1329);
module.exports["FormatError"] = $108b97800ea04239$export$7369836851cc1329;
module.exports["InvalidValueError"] = $108b97800ea04239$export$565c3afc07dfa382;
module.exports["InvalidValueTypeError"] = $108b97800ea04239$export$cbc0db47c750f7c9;
module.exports["MissingValueError"] = $108b97800ea04239$export$8bfc137e4d23fdf0;

});

parcelRegister("38rme", function(module, exports) {
$parcel$export(module.exports, "PART_TYPE", () => $2487571e238306d5$export$49694c2877b44c57);

var $euVWZ = parcelRequire("euVWZ");


var $1q4lC = parcelRequire("1q4lC");

var $2487571e238306d5$export$49694c2877b44c57;
(function(PART_TYPE) {
    PART_TYPE[PART_TYPE["literal"] = 0] = "literal";
    PART_TYPE[PART_TYPE["object"] = 1] = "object";
})($2487571e238306d5$export$49694c2877b44c57 || ($2487571e238306d5$export$49694c2877b44c57 = {}));
function $2487571e238306d5$var$mergeLiteral(parts) {
    if (parts.length < 2) return parts;
    return parts.reduce(function(all, part) {
        var lastPart = all[all.length - 1];
        if (!lastPart || lastPart.type !== $2487571e238306d5$export$49694c2877b44c57.literal || part.type !== $2487571e238306d5$export$49694c2877b44c57.literal) all.push(part);
        else lastPart.value += part.value;
        return all;
    }, []);
}
function $2487571e238306d5$export$df0c12a2d414a163(el) {
    return typeof el === 'function';
}
function $2487571e238306d5$export$275d4a3bb5f66fda(els, locales, formatters, formats, values, currentPluralValue, // For debugging
originalMessage) {
    // Hot path for straight simple msg translations
    if (els.length === 1 && (0, $euVWZ.isLiteralElement)(els[0])) return [
        {
            type: $2487571e238306d5$export$49694c2877b44c57.literal,
            value: els[0].value
        }
    ];
    var result = [];
    for(var _i = 0, els_1 = els; _i < els_1.length; _i++){
        var el = els_1[_i];
        // Exit early for string parts.
        if ((0, $euVWZ.isLiteralElement)(el)) {
            result.push({
                type: $2487571e238306d5$export$49694c2877b44c57.literal,
                value: el.value
            });
            continue;
        }
        // TODO: should this part be literal type?
        // Replace `#` in plural rules with the actual numeric value.
        if ((0, $euVWZ.isPoundElement)(el)) {
            if (typeof currentPluralValue === 'number') result.push({
                type: $2487571e238306d5$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales).format(currentPluralValue)
            });
            continue;
        }
        var varName = el.value;
        // Enforce that all required values are provided by the caller.
        if (!(values && varName in values)) throw new (0, $1q4lC.MissingValueError)(varName, originalMessage);
        var value = values[varName];
        if ((0, $euVWZ.isArgumentElement)(el)) {
            if (!value || typeof value === 'string' || typeof value === 'number') value = typeof value === 'string' || typeof value === 'number' ? String(value) : '';
            result.push({
                type: typeof value === 'string' ? $2487571e238306d5$export$49694c2877b44c57.literal : $2487571e238306d5$export$49694c2877b44c57.object,
                value: value
            });
            continue;
        }
        // Recursively format plural and select parts' option — which can be a
        // nested pattern structure. The choosing of the option to use is
        // abstracted-by and delegated-to the part helper object.
        if ((0, $euVWZ.isDateElement)(el)) {
            var style = typeof el.style === 'string' ? formats.date[el.style] : (0, $euVWZ.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            result.push({
                type: $2487571e238306d5$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $euVWZ.isTimeElement)(el)) {
            var style = typeof el.style === 'string' ? formats.time[el.style] : (0, $euVWZ.isDateTimeSkeleton)(el.style) ? el.style.parsedOptions : formats.time.medium;
            result.push({
                type: $2487571e238306d5$export$49694c2877b44c57.literal,
                value: formatters.getDateTimeFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $euVWZ.isNumberElement)(el)) {
            var style = typeof el.style === 'string' ? formats.number[el.style] : (0, $euVWZ.isNumberSkeleton)(el.style) ? el.style.parsedOptions : undefined;
            if (style && style.scale) value = value * (style.scale || 1);
            result.push({
                type: $2487571e238306d5$export$49694c2877b44c57.literal,
                value: formatters.getNumberFormat(locales, style).format(value)
            });
            continue;
        }
        if ((0, $euVWZ.isTagElement)(el)) {
            var children = el.children, value_1 = el.value;
            var formatFn = values[value_1];
            if (!$2487571e238306d5$export$df0c12a2d414a163(formatFn)) throw new (0, $1q4lC.InvalidValueTypeError)(value_1, 'function', originalMessage);
            var parts = $2487571e238306d5$export$275d4a3bb5f66fda(children, locales, formatters, formats, values, currentPluralValue);
            var chunks = formatFn(parts.map(function(p) {
                return p.value;
            }));
            if (!Array.isArray(chunks)) chunks = [
                chunks
            ];
            result.push.apply(result, chunks.map(function(c) {
                return {
                    type: typeof c === 'string' ? $2487571e238306d5$export$49694c2877b44c57.literal : $2487571e238306d5$export$49694c2877b44c57.object,
                    value: c
                };
            }));
        }
        if ((0, $euVWZ.isSelectElement)(el)) {
            var opt = el.options[value] || el.options.other;
            if (!opt) throw new (0, $1q4lC.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $2487571e238306d5$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values));
            continue;
        }
        if ((0, $euVWZ.isPluralElement)(el)) {
            var opt = el.options["=".concat(value)];
            if (!opt) {
                if (!Intl.PluralRules) throw new (0, $1q4lC.FormatError)("Intl.PluralRules is not available in this environment.\nTry polyfilling it using \"@formatjs/intl-pluralrules\"\n", (0, $1q4lC.ErrorCode).MISSING_INTL_API, originalMessage);
                var rule = formatters.getPluralRules(locales, {
                    type: el.pluralType
                }).select(value - (el.offset || 0));
                opt = el.options[rule] || el.options.other;
            }
            if (!opt) throw new (0, $1q4lC.InvalidValueError)(el.value, value, Object.keys(el.options), originalMessage);
            result.push.apply(result, $2487571e238306d5$export$275d4a3bb5f66fda(opt.value, locales, formatters, formats, values, value - (el.offset || 0)));
            continue;
        }
    }
    return $2487571e238306d5$var$mergeLiteral(result);
}
module.exports["isFormatXMLElementFn"] = $2487571e238306d5$export$df0c12a2d414a163;
module.exports["formatToParts"] = $2487571e238306d5$export$275d4a3bb5f66fda;

});

parcelRegister("gEeFR", function(module, exports) {

var $hXuPC = parcelRequire("hXuPC");


var $42omo = parcelRequire("42omo");


var $jaEJa = parcelRequire("jaEJa");

function $c1ebc3bcc5e06dde$export$f5708dca728d7177(condition, message, Err) {
    if (Err === void 0) Err = Error;
    if (!condition) throw new Err(message);
}
function $c1ebc3bcc5e06dde$export$45c4bbf6e55bba1f(intl) {
    $c1ebc3bcc5e06dde$export$f5708dca728d7177(intl, "[React Intl] Could not find required `intl` object. <IntlProvider> needs to exist in the component ancestry.");
}
var $c1ebc3bcc5e06dde$export$b52f8d6fc0d47415 = (0, $hXuPC.__assign)((0, $hXuPC.__assign)({}, (0, $jaEJa.DEFAULT_INTL_CONFIG)), {
    textComponent: $42omo.Fragment
});
var $c1ebc3bcc5e06dde$var$toKeyedReactNode = function(reactNode, key) {
    return $42omo.isValidElement(reactNode) ? $42omo.cloneElement(reactNode, {
        key: key
    }) : reactNode;
};
var $c1ebc3bcc5e06dde$export$d2fd241e0b53c057 = function(children) {
    var _a;
    /**
 * Note: {@link React.Children.map} will add its own index-based prefix to
 * every key anyway, so the auto-injected one doesn't even have to be unique.
 * This basically just tells React that it's explicit/intentional.
 */ return (_a = $42omo.Children.map(children, $c1ebc3bcc5e06dde$var$toKeyedReactNode)) !== null && _a !== void 0 ? _a : [];
};
function $c1ebc3bcc5e06dde$export$cfec03d26465fa63(formatXMLElementFn) {
    return function(parts) {
        // eslint-disable-next-line prefer-rest-params
        return formatXMLElementFn($c1ebc3bcc5e06dde$export$d2fd241e0b53c057(parts));
    };
}
function $c1ebc3bcc5e06dde$export$d36bdfa510afb180(objA, objB) {
    if (objA === objB) return true;
    if (!objA || !objB) return false;
    var aKeys = Object.keys(objA);
    var bKeys = Object.keys(objB);
    var len = aKeys.length;
    if (bKeys.length !== len) return false;
    for(var i = 0; i < len; i++){
        var key = aKeys[i];
        if (objA[key] !== objB[key] || !Object.prototype.hasOwnProperty.call(objB, key)) return false;
    }
    return true;
}
module.exports["invariant"] = $c1ebc3bcc5e06dde$export$f5708dca728d7177;
module.exports["invariantIntlContext"] = $c1ebc3bcc5e06dde$export$45c4bbf6e55bba1f;
module.exports["DEFAULT_INTL_CONFIG"] = $c1ebc3bcc5e06dde$export$b52f8d6fc0d47415;
module.exports["toKeyedReactNodeArray"] = $c1ebc3bcc5e06dde$export$d2fd241e0b53c057;
module.exports["assignUniqueKeysToParts"] = $c1ebc3bcc5e06dde$export$cfec03d26465fa63;
module.exports["shallowEqual"] = $c1ebc3bcc5e06dde$export$d36bdfa510afb180;

});

parcelRegister("djDjD", function(module, exports) {

$parcel$defineInteropFlag(module.exports);
$parcel$export(module.exports, "ErrorCode", () => (parcelRequire("1q4lC")).ErrorCode);
$parcel$export(module.exports, "FormatError", () => (parcelRequire("1q4lC")).FormatError);
$parcel$export(module.exports, "isFormatXMLElementFn", () => (parcelRequire("38rme")).isFormatXMLElementFn);
$parcel$export(module.exports, "IntlMessageFormat", () => (parcelRequire("9m5ne")).IntlMessageFormat);
/*
Copyright (c) 2014, Yahoo! Inc. All rights reserved.
Copyrights licensed under the New BSD License.
See the accompanying LICENSE file for terms.
*/ 
var $9m5ne = parcelRequire("9m5ne");

parcelRequire("1q4lC");

parcelRequire("38rme");

var $9b1b8bf8cfd46788$export$2e2bcd8739ae039 = (0, $9m5ne.IntlMessageFormat);

});

parcelRegister("awSkB", function(module, exports) {
// Unique ID creation requires a high quality random # generator.  In the
// browser this is a little complicated due to unknown quality of Math.random()
// and inconsistent support for the `crypto` API.  We do the best we can via
// feature-detection
// getRandomValues needs to be invoked in a context where "this" is a Crypto
// implementation. Also, find the complete implementation of crypto on IE11.
var $7aa70995ad661ded$var$getRandomValues = typeof crypto != 'undefined' && crypto.getRandomValues && crypto.getRandomValues.bind(crypto) || typeof msCrypto != 'undefined' && typeof window.msCrypto.getRandomValues == 'function' && msCrypto.getRandomValues.bind(msCrypto);
if ($7aa70995ad661ded$var$getRandomValues) {
    // WHATWG crypto RNG - http://wiki.whatwg.org/wiki/Crypto
    var $7aa70995ad661ded$var$rnds8 = new Uint8Array(16); // eslint-disable-line no-undef
    module.exports = function whatwgRNG() {
        $7aa70995ad661ded$var$getRandomValues($7aa70995ad661ded$var$rnds8);
        return $7aa70995ad661ded$var$rnds8;
    };
} else {
    // Math.random()-based (RNG)
    //
    // If all else fails, use Math.random().  It's fast, but is of unspecified
    // quality.
    var $7aa70995ad661ded$var$rnds = new Array(16);
    module.exports = function mathRNG() {
        for(var i = 0, r; i < 16; i++){
            if ((i & 0x03) === 0) r = Math.random() * 0x100000000;
            $7aa70995ad661ded$var$rnds[i] = r >>> ((i & 0x03) << 3) & 0xff;
        }
        return $7aa70995ad661ded$var$rnds;
    };
}

});

parcelRegister("aYYGS", function(module, exports) {
/**
 * Convert array of 16 byte values to UUID string format of the form:
 * XXXXXXXX-XXXX-XXXX-XXXX-XXXXXXXXXXXX
 */ var $7fee95d74ddd92b1$var$byteToHex = [];
for(var $7fee95d74ddd92b1$var$i = 0; $7fee95d74ddd92b1$var$i < 256; ++$7fee95d74ddd92b1$var$i)$7fee95d74ddd92b1$var$byteToHex[$7fee95d74ddd92b1$var$i] = ($7fee95d74ddd92b1$var$i + 0x100).toString(16).substr(1);
function $7fee95d74ddd92b1$var$bytesToUuid(buf, offset) {
    var i = offset || 0;
    var bth = $7fee95d74ddd92b1$var$byteToHex;
    // join used to fix memory issue caused by concatenation: https://bugs.chromium.org/p/v8/issues/detail?id=3175#c4
    return [
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        '-',
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]],
        bth[buf[i++]]
    ].join('');
}
module.exports = $7fee95d74ddd92b1$var$bytesToUuid;

});

parcelRegister("dsvEp", function(module, exports) {
function $9cc671136dcf5e2e$var$extendedTypeof(val) {
    if (val === null) return "null";
    if (Array.isArray(val)) return "array";
    return typeof val;
}
function $9cc671136dcf5e2e$export$23f2a1d2818174ef(val) {
    return $9cc671136dcf5e2e$var$extendedTypeof(val) === "object";
}
function $9cc671136dcf5e2e$export$8b22cf2602fb60ce(val) {
    return typeof Object(val)[Symbol.asyncIterator] === "function";
}
function $9cc671136dcf5e2e$export$407448d2b89b1813(val) {
    return $9cc671136dcf5e2e$export$23f2a1d2818174ef(val) && typeof Object(val)[Symbol.asyncIterator] === "function" && typeof val.return === "function";
}
function $9cc671136dcf5e2e$var$areGraphQLFormattedErrors(obj) {
    return Array.isArray(obj) && // must be at least one error
    obj.length > 0 && // error has at least a message
    obj.every((ob)=>"message" in ob);
}
function $9cc671136dcf5e2e$export$882b5998b3b9117c(reason, whenTooLong) {
    return reason.length < 124 ? reason : whenTooLong;
}
const $9cc671136dcf5e2e$export$2329c99376c9d0a4 = "graphql-transport-ws";
const $9cc671136dcf5e2e$export$96f57966bedc81b4 = "graphql-ws";
var $9cc671136dcf5e2e$export$e7094788287c5e9b = /* @__PURE__ */ ((CloseCode2)=>{
    CloseCode2[CloseCode2["InternalServerError"] = 4500] = "InternalServerError";
    CloseCode2[CloseCode2["InternalClientError"] = 4005] = "InternalClientError";
    CloseCode2[CloseCode2["BadRequest"] = 4400] = "BadRequest";
    CloseCode2[CloseCode2["BadResponse"] = 4004] = "BadResponse";
    CloseCode2[CloseCode2["Unauthorized"] = 4401] = "Unauthorized";
    CloseCode2[CloseCode2["Forbidden"] = 4403] = "Forbidden";
    CloseCode2[CloseCode2["SubprotocolNotAcceptable"] = 4406] = "SubprotocolNotAcceptable";
    CloseCode2[CloseCode2["ConnectionInitialisationTimeout"] = 4408] = "ConnectionInitialisationTimeout";
    CloseCode2[CloseCode2["ConnectionAcknowledgementTimeout"] = 4504] = "ConnectionAcknowledgementTimeout";
    CloseCode2[CloseCode2["SubscriberAlreadyExists"] = 4409] = "SubscriberAlreadyExists";
    CloseCode2[CloseCode2["TooManyInitialisationRequests"] = 4429] = "TooManyInitialisationRequests";
    return CloseCode2;
})($9cc671136dcf5e2e$export$e7094788287c5e9b || {});
var $9cc671136dcf5e2e$export$3a1a48c8f6ef640e = /* @__PURE__ */ ((MessageType2)=>{
    MessageType2["ConnectionInit"] = "connection_init";
    MessageType2["ConnectionAck"] = "connection_ack";
    MessageType2["Ping"] = "ping";
    MessageType2["Pong"] = "pong";
    MessageType2["Subscribe"] = "subscribe";
    MessageType2["Next"] = "next";
    MessageType2["Error"] = "error";
    MessageType2["Complete"] = "complete";
    return MessageType2;
})($9cc671136dcf5e2e$export$3a1a48c8f6ef640e || {});
function $9cc671136dcf5e2e$export$90a7f3efeed30595(val) {
    if (!$9cc671136dcf5e2e$export$23f2a1d2818174ef(val)) throw new Error(`Message is expected to be an object, but got ${$9cc671136dcf5e2e$var$extendedTypeof(val)}`);
    if (!val.type) throw new Error(`Message is missing the 'type' property`);
    if (typeof val.type !== "string") throw new Error(`Message is expects the 'type' property to be a string, but got ${$9cc671136dcf5e2e$var$extendedTypeof(val.type)}`);
    switch(val.type){
        case "connection_init" /* ConnectionInit */ :
        case "connection_ack" /* ConnectionAck */ :
        case "ping" /* Ping */ :
        case "pong" /* Pong */ :
            if (val.payload != null && !$9cc671136dcf5e2e$export$23f2a1d2818174ef(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object or nullish or missing, but got "${val.payload}"`);
            break;
        case "subscribe" /* Subscribe */ :
            if (typeof val.id !== "string") throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${$9cc671136dcf5e2e$var$extendedTypeof(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            if (!$9cc671136dcf5e2e$export$23f2a1d2818174ef(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object, but got ${$9cc671136dcf5e2e$var$extendedTypeof(val.payload)}`);
            if (typeof val.payload.query !== "string") throw new Error(`"${val.type}" message payload expects the 'query' property to be a string, but got ${$9cc671136dcf5e2e$var$extendedTypeof(val.payload.query)}`);
            if (val.payload.variables != null && !$9cc671136dcf5e2e$export$23f2a1d2818174ef(val.payload.variables)) throw new Error(`"${val.type}" message payload expects the 'variables' property to be a an object or nullish or missing, but got ${$9cc671136dcf5e2e$var$extendedTypeof(val.payload.variables)}`);
            if (val.payload.operationName != null && $9cc671136dcf5e2e$var$extendedTypeof(val.payload.operationName) !== "string") throw new Error(`"${val.type}" message payload expects the 'operationName' property to be a string or nullish or missing, but got ${$9cc671136dcf5e2e$var$extendedTypeof(val.payload.operationName)}`);
            if (val.payload.extensions != null && !$9cc671136dcf5e2e$export$23f2a1d2818174ef(val.payload.extensions)) throw new Error(`"${val.type}" message payload expects the 'extensions' property to be a an object or nullish or missing, but got ${$9cc671136dcf5e2e$var$extendedTypeof(val.payload.extensions)}`);
            break;
        case "next" /* Next */ :
            if (typeof val.id !== "string") throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${$9cc671136dcf5e2e$var$extendedTypeof(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            if (!$9cc671136dcf5e2e$export$23f2a1d2818174ef(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an object, but got ${$9cc671136dcf5e2e$var$extendedTypeof(val.payload)}`);
            break;
        case "error" /* Error */ :
            if (typeof val.id !== "string") throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${$9cc671136dcf5e2e$var$extendedTypeof(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            if (!$9cc671136dcf5e2e$var$areGraphQLFormattedErrors(val.payload)) throw new Error(`"${val.type}" message expects the 'payload' property to be an array of GraphQL errors, but got ${JSON.stringify(val.payload)}`);
            break;
        case "complete" /* Complete */ :
            if (typeof val.id !== "string") throw new Error(`"${val.type}" message expects the 'id' property to be a string, but got ${$9cc671136dcf5e2e$var$extendedTypeof(val.id)}`);
            if (!val.id) throw new Error(`"${val.type}" message requires a non-empty 'id' property`);
            break;
        default:
            throw new Error(`Invalid message 'type' property "${val.type}"`);
    }
    return val;
}
function $9cc671136dcf5e2e$export$ffb5f4729a158638(data, reviver) {
    return $9cc671136dcf5e2e$export$90a7f3efeed30595(typeof data === "string" ? JSON.parse(data, reviver) : data);
}
function $9cc671136dcf5e2e$export$2408f22a0fab9ae5(msg, replacer) {
    $9cc671136dcf5e2e$export$90a7f3efeed30595(msg);
    return JSON.stringify(msg, replacer);
}
module.exports["i"] = $9cc671136dcf5e2e$export$23f2a1d2818174ef;
module.exports["l"] = $9cc671136dcf5e2e$export$882b5998b3b9117c;
module.exports["G"] = $9cc671136dcf5e2e$export$2329c99376c9d0a4;
module.exports["C"] = $9cc671136dcf5e2e$export$e7094788287c5e9b;
module.exports["M"] = $9cc671136dcf5e2e$export$3a1a48c8f6ef640e;
module.exports["p"] = $9cc671136dcf5e2e$export$ffb5f4729a158638;
module.exports["s"] = $9cc671136dcf5e2e$export$2408f22a0fab9ae5;

});


$parcel$global.rlb("hoCeh")
//# sourceMappingURL=vendors.5865cb34.js.map
